export enum UserEvents {
  LOADED_CONTENT_PAGE = "Loaded Content Page",
  CLICKED_CONTENT_BANNER = "Clicked Hero Content",
  SHOW_ATTENDANCE_RECORDED = "Show Attendance Recorded",
  LOGGED_IN = "Logged In",
  LOGGED_OUT = "Logged Out",
  AUTHENTICATED_SESSION_STARTED = "Authenticated Session Started",
  LOGIN_FAILED = "Login Failed",
  SIGNED_UP = "Signed Up",
  OTP_SIGN_IN_FAILED = "OTP Sign In Failed",
  ATTEMPTED_SIGNUP_ACCOUNT_ALREADY_EXISTS = "Attempted signing up for an account that already exists",
  ATTEMPTED_SIGNUP_ACCOUNT_ALREADY_EXISTS_NO_AUTH = "Attempted signing up for an account that already exists but not authenticated",
  PASSCODE_REQUESTED = "Passcode Requested",
  PASSCODE_SUBMITTED = "Passcode Submitted",
  PASSCODE_RESENT = "Passcode Resent",
  PASSCODE_RESEND_FAILED = "Passcode Resend Failed",
  PASSCODE_SUCCESSFULLY_VERIFIED = "Passcode Successfully Verified",
  PASSCODE_FAILED_VERIFICATION = "Passcode Failed Verification",
  PHONE_NUMBER_UPDATED = "Phone Number Updated",
  PHONE_NUMBER_DELETED = "Phone Number Deleted",
  PHONE_NUMBER_LINKED = "Phone Number Linked",
  EMAIL_LINKED = "Email Linked",
  EMAIL_UPDATED = "Email Updated",
  EMAIL_DELETED = "Email Deleted",
  LINK_CLICKED = "Link Clicked",
  TICKETS_COMPONENT_LOADED = "Tickets Component Loaded (/tickets page)",
  BUY_TICKETS_CLICKED = "Buy Tickets Clicked",
  CHOOSE_DATES_CLICKED = "Choose Dates Clicked",
  TICKET_REDIRECT = "Ticket Redirect",
  TICKET_REDIRECT_PAST_EVENT = "Ticket Redirect for Past Event",
  CLICKED_UNLOCK_SPECIAL = "Clicked Unlock Special",
  CLICKED_UNLOCK_BUNDLE = "Clicked Unlock Bundle",
  CLICKED_WATCH_SPECIAL = "Clicked Watch Special",
  CLICKED_WATCH_BUNDLE = "Clicked Watch Bundle",
  CLICKED_WATCH_UNLOCKED_SPECIAL = "Clicked Watch Special for an Unlocked Special",
  CLICKED_WATCH_UNLOCKED_BUNDLE = "Clicked Watch Unlocked Bundle",
  CLICKED_SEE_MORE_SPECIALS = "Clicked See More Specials",
  CLICKED_SEE_MORE_PODCASTS = "Clicked See More Podcasts",
  CLICKED_SEE_MORE_BUNDLES = "Clicked See More Bundles",
  CLICKED_WATCH_FEATURED_SPECIAL = "Clicked Watch Special for the Featured Special",
  CLICKED_SHARE_SHOW = "Clicked Share Show",
  COPIED_PRESALE_CODE_TO_CLIPBOARD = "Copied Presale Code To Clipboard",
  FOLLOWED_COMEDIAN = "Followed Comedian",
  UNFOLLOWED_COMEDIAN = "Unfollowed Comedian",
  VISITED_QR_CODE_SIGNUP_FORM = "Visited QR Code Signup Form",
  CLICKED_MENU_DROPDOWN = "Clicked on Menu Dropdown",
  NAVIGATE_TO_FEED_FROM_DROPDOWN = "Navigate to Feed from Dropdown",
  NAVIGATE_TO_LIBRARY_FROM_DROPDOWN = "Navigate to Library from Dropdown",
  NAVIGATE_TO_SHOWS_NEARBY_FROM_HEADER_BTN = "Navigate to Shows Nearby from Header button",
  NAVIGATE_TO_PROFILE_FROM_DROPDOWN = "Navigate to Profile from Dropdown",
  NAVIGATE_TO_DASHBOARD_FROM_NAV_BUTTON = "Navigate to Dashboard from Nav Button",
  TIP_COMEDIAN = "TIP_COMEDIAN",
  SUBMITTED_REQUEST_FOR_SHOW = "Submitted Request for Show",
  DISMISSED_SHOW_REQUEST_FORM = "Dismissed Form for Show Request",
  OAUTH_SIGN_IN = "OAuth Sign In",
  OAUTH_SIGN_IN_ATTEMPT = "Oauth Sign In Attempt",
  OAUTH_SIGN_IN_FAILED = "Oauth Sign In Failed",
  OAUTH_PAGE_LOADED = "Oauth Page Loaded",
  FIRST_TIME_SIGNUP = "First Time Signup",
  SEARCHED_VENUE_PAGES = "Searched across Venue Pages",
  SEARCHED_VENUE_PAGES_NO_RESULTS = "Searched across Venue Pages - No Results",
  ONBOARDING_COMPLETE = "Onboarding Complete",
  CLICKED_DOWNLOAD_ON_THE_APP_STORE = "Clicked Download on the App Store",
  USER_CLICKED_SHORT_LINK = "User Clicked Short Link",
  FEATURE_ANNOUNCEMENT_MODAL_DISMISSED = "User Dismissed Feature Announcement Modal",
  FEATURE_ANNOUNCEMENT_MODAL_ACTION_TAKEN = "User Took Action on Feature Announcement Modal",
}

export enum FollowComedianEvents {
  COMEDIAN_LANDING_PAGE = "Clicked Follow (Comedian Landing Page)",
  COMEDIAN_FOLLOW_PAGE = "Clicked Follow (Comedian Follow Page)",
  LIBRARY = "Clicked Follow (Library)",
  SHOWS_NEARBY = "Clicked Follow (Shows Nearby)",
  SUGGESTED = "Clicked Follow (Suggested Comedians Onboarding)",
  CLAP_REACTION_BUTTON = "Clicked Follow (Clap Reaction Button)",
  FEED_FEATURED_COMEDIAN_CARD = "Clicked Follow (Feed Featured Comedian Card)",
  FEED_SUGGESTED_COMEDIAN_CARD = "Clicked Follow (Feed Suggested Comedian Card)",
  FEED_VIDEO_CARD = "Clicked Follow (Feed Video Card)",
  SEARCH = "Clicked Follow (Search)",
  EVENT_LANDING = "Clicked Follow (Event Landing Page)",
  VENUE_PAGE = "Clicked Follow (Venue Page)",
  PAYMENT_FORM = "Clicked Follow (Payment Form)",
  FREE_CHECKOUT_ALREADY_LOGGED_IN = "Clicked Follow (Free Checkout)",
  PAID_CHECKOUT_ALREADY_LOGGED_IN = "Clicked Follow (Paid Checkout)",
}

// Per-location unfollow click events. Fired the moment an unfollow/
// unsubscribe button is pressed, to measure click → completion drop-off
// for unfollow flows the same way FollowComedianEvents does for follows.
export enum UnfollowComedianEvents {
  VENUE_PAGE = "Clicked Unfollow (Venue Page)",
  NOTIFICATION_PREFERENCES_DROPDOWN = "Clicked Unfollow (Notification Preferences Dropdown)",
  PROFILE_SUBSCRIPTIONS_MODAL = "Clicked Unfollow (Profile Subscriptions Modal)",
  CANCEL_SUBSCRIPTION_MODAL = "Clicked Unfollow (Cancel Subscription Modal)",
}

export enum HeaderEvents {
  CLICKED_SIGN_IN = "Clicked Sign in from Header",
  CLICKED_SUBSCRIBE_FROM_HEADER = "Clicked Subscribe from Header",
  CLICKED_HEADER_LOGO = "Clicked Logo in the Header",
  LOADED_HEADER = "Loaded Header",
  LOADED_HEADER_VARIANT = "Loaded Header Variant",
  NAVIGATE_TO_HOME = "Navigate to Home",
  NAVIGATE_TO_LIBRARY_FROM_HOME = "Navigate to Library from Home",
  NAVIGATE_TO_FEED_FROM_HOME = "Navigate to Feed from Home",
  CLICKED_PRIVACY_POLICY = "Clicked Privacy Policy",
  CLICKED_TERMS_OF_SERVICE = "Clicked Terms of Service",
  CLICKED_ABOUT_US = "clicked_about_us",
  CLICKED_TIXOLOGI = "clicked_tixologi",
  CLICKED_BLOG = "clicked_blog",
}

export enum NewsLetterEvents {
  DELIVERED = "Newsletter Delivered",
  FAILED_DELIVERY = "Newsletter Failed Delivery",
  OPENED = "Newsletter Opened",
  CLICKED = "Newsletter Clicked",
  CLICKED_VIDEO_ATTRIBUTION = "Newsletter Clicked Video",
  CLICKED_BUY_TICKETS_ATTRIBUTION = "Newsletter Clicked Buy Tickets",
  MARKED_SPAM = "Newsletter Marked Spam",
  UNSUBSCRIBED = "Newsletter Unsubscribed",
  UNSUBSCRIBE_CLICKED = "Newsletter Unsubscribe Clicked",
  OTHER_EVENTS = "Newsletter Other Events",
}

export enum BaseEmailEvents {
  CLICKED = "Email Clicked",
  OPENED = "Email Opened",
  UNMAPPED_EVENT = "Unmapped Email Event",
  UNSUBSCRIBED = "Email Unsubscribed",
  DELIVERED = "Email Delivered",
  FAILED_DELIVERY = "Email Failed Delivery",
  COMPLAINED_OR_MARKED_SPAM = "Email Complained or Marked Spam",
}

export enum ComedianDigestEmailEvents {
  DELIVERED = "Comedian Digest Delivered",
  OPENED = "Comedian Digest Opened",
  CLICKED = "Comedian Digest Clicked",
  UNSUBSCRIBED = "Comedian Digest Unsubscribed",
  COMPLAINED = "Comedian Digest Complained",
  FAILED_DELIVERY = "Comedian Digest Failed Delivery",
}

export enum OnboardingEvents {
  ACCEPTED_TERMS = "Onboarding - Accepted Terms",
}

export enum HealthCheckEvents {
  MG_SIGNATURE_VALID = "MG Signature Valid",
  MG_SIGNATURE_INVALID = "MG Signature Invalid",
  WEEKLY_EMAIL_BATCH_ERROR = "Failure in Sending Weekly Email Batch",
  WEEKLY_EMAIL_BATCH_SUCCESS = "Sent Weekly Email Batch",
  WEEKLY_EMAIL_SINGLE_ERROR = "Failed to Send One Weekly Email",
  WEEKLY_EMAIL_SINGLE_SUCCESS = "Sent One Weekly Email",
  WEEKLY_EMAIL_SINGLE_SKIPPED = "Skipped Sending Weekly Email",
  WEEKLY_EMAIL_BATCH_FETCH = "Fetched Weekly Email Audience",
  PROMO_EMAIL_BATCH_ERROR = "Failure in Sending Promo Email Batch",
  PROMO_EMAIL_BATCH_SUCCESS = "Sent Promo Email Batch",
  PROMO_EMAIL_SINGLE_ERROR = "Failed to Send One Promo Email",
  PROMO_EMAIL_SINGLE_SUCCESS = "Sent One Promo Email",
  PROMO_EMAIL_SINGLE_SKIPPED = "Skipped Sending Promo Email",
  PROMO_EMAIL_BATCH_FETCH = "Fetched Promo Email Audience",
  BILLING_EMAIL_ERROR = "Failure in Sending Billing Email",
  BILLING_EMAIL_SUCCESS = "Sent Billing Email",
}

export enum SouthpawEvents {
  InitiationFailed = "Southpaw job PickedUp but not Initiated",
  InitiateError = "Southpaw initiate-scheduled-jobs API call failed",
  SendBatchError = "Southpaw job execute-job failed",
  SendBatchSuccess = "Southpaw job execute-job succeeded",
}

export enum SubscriptionEvents {
  GO_BACK = "Clicked Go Back",
  UNFOLLOWED_COMEDIAN = "Clicked Unsubscribe Me (Unfollowed Comedian)",
  CANCEL_PLAN = "Clicked Cancel Plan",
  CANCEL_PLAN_AND_UNFOLLOW = "Clicked Cancel Plan and Unfollowed Comedian",
  ONBOARD_USER = "Onboard User",
  NAVIGATED_TO_FREE_SUBSCRIPTIONS = "Navigated to Free Subscriptions",
  NAVIGATED_TO_PAID_SUBSCRIPTIONS = "Navigated to Paid Subscriptions",
  OPENED_CANCEL_SUBSCRIPTION_MODAL = "Opened Cancel Subscription Modal",
  NAVIGATED_TO_INVOICES = "Navigated to Invoices",
  DOWNLOAD_INVOICE_PDF = "Clicked Download PDF",
  UPGRADE_TIER = "Confirmed Subscription Tier Upgrade",
  DOWNGRADE_TIER = "Confirmed Subscription Tier Downgrade",
}

export enum ComedianLandingPageEvents {
  SWITCHED_CONTENT_TYPE = "Clicked on a different category of content",
  DISMISSED_SIGN_UP_FORM = "Dismissed Comedian Landing Page Sign Up Form",
  SEE_ALL_SHOWS_CLICKED = "Clicked See All Shows on Comedian Landing Page",
  SHOW_LESS_SHOWS_CLICKED = "Clicked Show Less Shows on Comedian Landing Page",
  LOADED_COMEDIAN_SUB_PAGE = "Loaded Comedian Sub Page",
  SEE_PLANS_CLICKED = "Clicked See Plans on Comedian Landing Page",
}

export enum DashboardEvents {
  LOADED_DASHBOARD_PORTAL = "Loaded Dashboard Portal",
  NAVIGATE_TO_DASHBOARD_FROM_DASHBOARD_PORTAL = "Navigate to Dashboard from Dashboard Portal",
  LOADED_DASHBOARD = "Loaded Dashboard",
  OPENED_RECOMMENDATIONS = "Opened Recommendations",
  OPENED_AUDIENCE_SECTION = "Opened Audience Section",
  OPENED_DEEP_DIVE_SECTION = "Opened Deep Dive Section",
  OPENED_CONTENT_MANAGER_SECTION = "Opened Content Manager Section",
  OPENED_TICKETING_SECTION = "Opened Ticketing Section",
  OPENED_TOUR_DATES_SECTION = "Opened Tour Dates Section",
  OPENED_MESSAGES_SECTION = "Opened Messages Section",
  CLICKED_EMAIL_RECOMMENDATIONS = "Clicked Email Recommendations",
  CLICKED_ADS_RECOMMENDATIONS = "Clicked Ads Recommendations",
  CLICKED_TOUR_RECOMMENDATIONS = "Clicked Tour Recommendations",
  EXPORTED_SUBSCRIBER_LIST = "[Comedian Dashboard - Audience] Exported Subscriber List",
  COMEDIAN_CLICK_DASHBOARD_SIDEBAR = "[Comedian Dashboard] Clicked Dashboard Sidebar Item",
  UPDATED_PROFILE = "[Comedian Dashboard] Updated Profile",
}

export enum DashboardTourDatesEvents {
  VENUE_SEARCH_NO_RESULTS = "[Comedian Dashboard - Tour Dates] Venue Search - No Results",
  VENUE_SELECTED = "[Comedian Dashboard - Tour Dates] Venue Selected",
  TOUR_DATE_UPDATE_SUCCESSFUL = "[Comedian Dashboard - Tour Dates] Tour Date Update Successful",
  TOUR_DATE_UPDATE_FAILED = "[Comedian Dashboard - Tour Dates] Tour Date Update Failed",
  TOUR_DATE_HIDDEN = "[Comedian Dashboard - Tour Dates] Tour Date Hidden",
  TOUR_DATE_RESTORED = "[Comedian Dashboard - Tour Dates] Tour Date Restored",
  TOUR_DATE_VISIBILITY_CHANGE_FAILED = "[Comedian Dashboard - Tour Dates] Tour Date Visibility Change Failed",
  TOUR_DATE_DELETED = "[Comedian Dashboard - Tour Dates] Tour Date Deleted",
  TOUR_DATE_DELETION_FAILED = "[Comedian Dashboard - Tour Dates] Tour Date Deletion Failed",
  TOUR_DATE_DUPLICATED = "[Comedian Dashboard - Tour Dates] Tour Date Duplicated",
  TOUR_DATE_EDIT_CLICKED = "[Comedian Dashboard - Tour Dates] Tour Date Edit Clicked",
  GROUP_OF_SHOWS_LINK_CLICKED = "[Comedian Dashboard - Tour Dates] Group of Shows Link Clicked",
  TOUR_DATE_SOLD_OUT_CLICKED = "[Comedian Dashboard - Tour Dates] Tour Date Sold Out Clicked",
  TOUR_DATE_LOW_TICKETS_CLICKED = "[Comedian Dashboard - Tour Dates] Tour Date Low Tickets Clicked",
  ADD_SHOW_CLICKED = "[Comedian Dashboard - Tour Dates] Add Show Clicked",
  CLICKED_GO_BACK = "[Comedian Dashboard - Tour Dates] Clicked Go Back",
  TOUR_DATE_SCHEDULED = "[Comedian Dashboard - Tour Dates] Tour Date Scheduled",
  TOUR_DATE_SCHEDULE_UPDATED = "[Comedian Dashboard - Tour Dates] Tour Date Schedule Updated",
  TOUR_DATE_SCHEDULE_CANCELLED = "[Comedian Dashboard - Tour Dates] Tour Date Schedule Cancelled",
}

/**
 * The rate-the-moment "How easy was it to ...?" feedback prompt funnel, shared
 * across every Artist Value surface (show / content / message / newsletter …).
 * Each event carries a `surface` property so one funnel filters by surface
 * (PUN-5039).
 */
export enum ArtistValueFeedbackEvents {
  SHOWN = "[Artist Value] Feedback Prompt Shown",
  SUBMITTED = "[Artist Value] Feedback Submitted",
  DISMISSED = "[Artist Value] Feedback Dismissed",
}

export enum DashboardMessagesEvents {
  CREATE_LIST_CLICKED = "[Comedian Dashboard - Upload Contacts] Create List Clicked",
  TARGETING_CHANGED = "[Comedian Dashboard - Messages] Targeting Changed",
  MESSAGE_SUBMITTED = "[Comedian Dashboard - Messages] Message Submitted",
  SUBMISSION_FAILED = "[Comedian Dashboard - Messages] Submission Failed",
  CONTACT_IMPORT_STARTED = "[Comedian Dashboard - Upload Contacts] Contact Import Started",
  CONTACT_IMPORT_COMPLETED = "[Comedian Dashboard - Upload Contacts] Contact Import Completed",
  CONTACT_IMPORT_FAILED = "[Comedian Dashboard - Upload Contacts] Contact Import Failed",
  CONTACT_LIST_DELETED = "[Comedian Dashboard - Upload Contacts] Contact List Deleted",
  IMPORT_CHOOSE_FILE_CLICKED = "[Comedian Dashboard - Upload Contacts] Choose File Clicked",
  IMPORT_FILE_DROPPED = "[Comedian Dashboard - Upload Contacts] File Dropped",
  IMPORT_SAMPLE_CSV_DOWNLOADED = "[Comedian Dashboard - Upload Contacts] Sample CSV Downloaded",
  IMPORT_CANCELLED = "[Comedian Dashboard - Upload Contacts] Import Cancelled",
  CONTACT_LIST_RENAMED = "[Comedian Dashboard - Upload Contacts] Contact List Renamed",
  CONTACT_LIST_RENAME_FAILED = "[Comedian Dashboard - Upload Contacts] Contact List Rename Failed",
  CONTACT_LIST_DELETE_FAILED = "[Comedian Dashboard - Upload Contacts] Contact List Delete Failed",
  /** Properties: { comedian_id, job_id, source: "menu" | "row" } */
  SENT_MESSAGE_VIEWED = "[Comedian Dashboard - Messages] Sent Message Viewed",
  /** Properties: { comedian_id, job_id, use_case } */
  SEND_AGAIN_CLICKED = "[Comedian Dashboard - Messages] Send Again Clicked",
  /** Properties: { comedian_id, job_id } */
  SCHEDULED_SEND_CANCELLED = "[Comedian Dashboard - Messages] Scheduled Send Cancelled",
  /** Properties: { comedian_id, tab, filter: "type" | "channel", value } — v2 jobs table dropdown changes, not search keystrokes. */
  TABLE_FILTERED = "[Comedian Dashboard - Messages] Table Filtered",
  /** Properties: { comedian_id, tab, page_size } */
  TABLE_PAGE_SIZE_CHANGED = "[Comedian Dashboard - Messages] Table Page Size Changed",
  /** Properties: { comedian_id, job_id } */
  SCHEDULED_MESSAGE_EDIT_OPENED = "[Comedian Dashboard - Messages] Scheduled Message Edit Opened",
  /** Properties: { comedian_id, job_id } */
  SCHEDULED_MESSAGE_EDITED = "[Comedian Dashboard - Messages] Scheduled Message Edited",
}

/**
 * The Audience List surface (All contacts, Lists, one list's page). Every
 * payload carries `comedian_id`; an event that more than one page fires also
 * carries `location`, an `AudienceLocation`. See docs/specs/mixpanel.md.
 */
export enum DashboardAudienceEvents {
  /** Server-tracked from the route, so it carries no browser attribution. */
  PAGE_VIEWED = "[Comedian Dashboard - Audience] Page Viewed",
  CONTACTS_SEARCHED = "[Comedian Dashboard - Audience] Contacts Searched",
  CITY_FILTER_CHANGED = "[Comedian Dashboard - Audience] City Filter Changed",
  RADIUS_CHANGED = "[Comedian Dashboard - Audience] Radius Changed",
  LOAD_MORE_CLICKED = "[Comedian Dashboard - Audience] Load More Clicked",
  ALL_CITIES_TOGGLED = "[Comedian Dashboard - Audience] All Cities Toggled",
  NEXT_STEP_CLICKED = "[Comedian Dashboard - Audience] Next Step Clicked",
  LIST_OPENED = "[Comedian Dashboard - Audience] List Opened",
  EXPORT_FAILED = "[Comedian Dashboard - Audience] Export Failed",
  IMPORT_REJECTED = "[Comedian Dashboard - Audience] Import Rejected",
}

/** The Audience List page an event fired from: the `location` property, one value per page. */
export const AudienceLocation = {
  ALL_CONTACTS_LIST: "all_contacts_list",
  ALL_CONTACTS_MAP: "all_contacts_map",
  LISTS: "lists",
  LIST_DETAIL: "list_detail",
} as const;
export type AudienceLocation =
  (typeof AudienceLocation)[keyof typeof AudienceLocation];

/**
 * M1 newsletter compose flow (packages/messaging's local-send MVP — see
 * newsletter-issues.ts). Distinct from `NewsLetterEvents` above, which tracks
 * the *recipient*-side outcomes of a delivered email, not the comedian's
 * compose/send actions in the dashboard.
 */
export enum NewsletterTabEvents {
  OPENED = "[Comedian Dashboard - Newsletter] Opened",
  COMPOSE_STARTED = "[Comedian Dashboard - Newsletter] Compose Started",
  /** Properties: { comedianId, audienceCount, source?, series_id?,
   *  slot_date? } — `source` (M28) is `"preview"` when Send now was
   *  confirmed from the row-click preview dialog's footer (compose's own
   *  Send-or-Schedule flow keeps firing un-sourced — historical baseline);
   *  a preview fire also carries `series_id`/`slot_date` when it originated
   *  from a series/cadence slot's preview. */
  ISSUE_SENT = "[Comedian Dashboard - Newsletter] Issue Sent",
  /** M2: the "Past issues" history list rendered (as opposed to the empty
   *  state or compose screen) — fires once per mount. */
  HOME_VIEWED = "[Comedian Dashboard - Newsletter] Home Viewed",
  /** M2: the per-issue send analytics (delivered/opens/clicks trio) rendered
   *  alongside the history list — fires once per mount, only when at least
   *  one issue (and therefore at least one stats trio) is visible. */
  ISSUE_STATS_VIEWED = "[Comedian Dashboard - Newsletter] Issue Stats Viewed",
  /** M4: a series (recurring cadence) created. Properties: { comedianId,
   *  frequency, day_of_week, week_of_month?, send_mode, ends_type,
   *  starts_type, start_date?, series_id, series_count } — `send_mode`
   *  ("auto" | "manual") and `ends_type` ("never" | "on-date" |
   *  "after-count") added with the series editor; `series_id`/`series_count`
   *  (total after the save) added with multi-series; `starts_type` ("asap" |
   *  "on-date") and `start_date` ("YYYY-MM-DD", on-date only) added with the
   *  two-step editor's Starts control. M29: `reminder_channel` was retired
   *  (the email/SMS reminder channel picker was replaced by
   *  SERIES_CALENDAR_ADDED's add-to-calendar actions) and is no longer
   *  emitted on this event. */
  CADENCE_SET = "[Comedian Dashboard - Newsletter] Cadence Set",
  /** M4: an existing series' schedule changed. Same properties as
   *  CADENCE_SET — including the M29 `reminder_channel` retirement. */
  CADENCE_CHANGED = "[Comedian Dashboard - Newsletter] Cadence Changed",
  /** M4: a series deleted. Properties: { comedianId, series_id,
   *  series_count } — count is the total REMAINING after the delete. */
  CADENCE_CLEARED = "[Comedian Dashboard - Newsletter] Cadence Cleared",
  /** Multi-series: a series paused/resumed from the Series card's action
   *  menu — a paused series stays listed but contributes no planned slots
   *  and no nudge. Properties: { comedianId, series_id, enabled }. */
  SERIES_TOGGLED = "[Comedian Dashboard - Newsletter] Series Toggled",
  /** Multi-series: a series duplicated from the Series card's action menu.
   *  The copy ("<name> copy") starts PAUSED (enabled=false). Properties:
   *  { comedianId, source_series_id, series_id, series_count } — count is
   *  the total AFTER the duplicate. */
  SERIES_DUPLICATED = "[Comedian Dashboard - Newsletter] Series Duplicated",
  /** A completed series extended from its row menu's quick-extend dialog —
   *  either a raised `after-count` target, a new `on-date` end, or the end
   *  removed entirely. Properties: { comedianId, series_id, ends_type }
   *  (`ends_type` is the NEW end's type, "never" when removed). */
  SERIES_EXTENDED = "[Comedian Dashboard - Newsletter] Series Extended",
  /** "Draft next {noun}" clicked in a Series row's "⋮" menu — deep-links the
   *  series' first planned slot into compose, creating the slot's draft when
   *  it has none yet. Properties: { comedianId, series_id, destination:
   *  "draft" | "new_slot_draft" }. */
  DRAFT_NEXT_CLICKED = "[Comedian Dashboard - Newsletter] Draft Next Clicked",
  /** M4: the nudge dismissed without composing. Properties: { comedianId,
   *  tier, series_id } — `tier` (added M11) is the DueState the nudge was
   *  showing at the moment of dismissal ("lead" | "due" | "overdue" |
   *  "comeback"); `series_id` (multi-series) is the series whose nudge won
   *  the urgency pick and received the dismissal. */
  NUDGE_DISMISSED = "[Comedian Dashboard - Newsletter] Nudge Dismissed",
  /** M11: the reminder lead-time setting saved with a value different from
   *  what was stored (or the default, if none was stored). Properties:
   *  { comedianId, lead_time }. */
  REMINDER_SET = "[Comedian Dashboard - Newsletter] Reminder Set",
  /** The Newsletter tab's Create funnel. Historically the tiered nudge CTA
   *  (lead/due/overdue/comeback) fired this too; the banner's boxed nudge was
   *  removed, so from the Newsletter tab only `tier: "none"` still fires —
   *  the page header's Create ▾ (`destination: "compose"`, always a fresh
   *  compose; its "Create series" item sends `"series_editor"`) and the
   *  Suggestion card's create-first state (`"compose"`). Properties:
   *  { comedianId, tier, destination: "compose" | "draft" |
   *  "series_editor" }. */
  NUDGE_CTA_CLICKED = "[Comedian Dashboard - Newsletter] Nudge CTA Clicked",
  /** M9: a compose session's first successful autosave (fires once per
   *  session, not per write). Properties: { comedianId }. */
  DRAFT_SAVED = "[Comedian Dashboard - Newsletter] Draft Saved",
  /** M9: a draft reopened from the overview. Properties: { comedianId,
   *  source: "drafts_list" | "calendar" | "preview" } — `"drafts_list"`
   *  fires from BOTH the Drafts row's click target (rows resume compose)
   *  and the "⋮" menu's Edit (separate click targets, same funnel step);
   *  `"preview"` (M28) is the preview dialog's Edit CTA (the preview now
   *  opens from the "⋮" menu's Preview item — see
   *  `NewsletterDraftResumeSource`). */
  DRAFT_RESUMED = "[Comedian Dashboard - Newsletter] Draft Resumed",
  /** M9: a draft deleted from the Drafts list. Properties: { comedianId }. */
  DRAFT_DELETED = "[Comedian Dashboard - Newsletter] Draft Deleted",
  /** A draft duplicated from the Drafts list's "⋮" action menu. Subject
   *  ("<subject> copy") and content are copied; slot attachment, schedule,
   *  and approval are not. Fires at click (like DRAFT_DELETED), so it carries
   *  no new-draft id. Properties: { comedianId }. */
  DRAFT_DUPLICATED = "[Comedian Dashboard - Newsletter] Draft Duplicated",
  /** M10: the planned queue rendered (as opposed to being empty because no
   *  cadence is set) — fires once per mount, mirroring HOME_VIEWED. Since the
   *  Planned tab became the Series tab it fires from the grouped-by-series
   *  view (SeriesSlotGroups, the old tab's successor). Properties:
   *  { comedianId, slotCount, draftLinkedCount }. */
  PLAN_VIEWED = "[Comedian Dashboard - Newsletter] Plan Viewed",
  /** M10: a planned-issue slot card tapped, opening compose pre-seeded and
   *  pre-dated for that slot. Properties: { comedianId, slotDate, hasDraft,
   *  rolledForward, kind, source? } — `kind` (added M18) is "cadence" |
   *  "scheduled"; `slotDate` is the slot's occurrence/scheduled date
   *  (`YYYY-MM-DD`) for BOTH kinds (never the slot id — a scheduled slot's id
   *  is a uuid); `source` (M27) is `"calendar"` when the tap came from the
   *  overlay calendar's chip, `"preview"` (M28) when it came from the
   *  preview dialog's Edit/Start-writing CTA — the Planned list's own
   *  `handleClick` keeps firing un-sourced, and it now backs BOTH the row's
   *  click target (rows open compose) and the "⋮" menu's Edit/Start
   *  Draft/Open item. The source vocabulary is typed as
   *  `NewsletterSlotOpenSource` (messaging's `planned/planned-slots.ts`) —
   *  `satisfies` it at call sites. */
  SLOT_OPENED = "[Comedian Dashboard - Newsletter] Slot Opened",
  /** Multi-series: a planned slot's title renamed inline from the Planned
   *  queue. Properties: { comedianId, slot_date, series_id, has_draft } —
   *  `has_draft` distinguishes a draft-subject rewrite (true) from a stored
   *  custom title on an unclaimed slot (false); `series_id` is null for a
   *  scheduled slot. */
  SLOT_RENAMED = "[Comedian Dashboard - Newsletter] Slot Renamed",
  /** M12: a half-idea jotted into the idea bank. Properties: { comedianId }. */
  IDEA_ADDED = "[Comedian Dashboard - Newsletter] Idea Added",
  /** M12: an idea's "Start writing" tapped — the idea soft-deletes and its
   *  title seeds a fresh compose session. Properties: { comedianId }. */
  IDEA_PROMOTED = "[Comedian Dashboard - Newsletter] Idea Promoted",
  /** M12: an idea removed from the idea bank via its inline delete.
   *  Properties: { comedianId }. */
  IDEA_DELETED = "[Comedian Dashboard - Newsletter] Idea Deleted",
  /** M13: the compact subscribers card tapped, expanding the full subscriber
   *  list in place of it and the schedule card. Properties: { comedianId,
   *  subscriber_count }. */
  SUBSCRIBERS_EXPANDED = "[Comedian Dashboard - Newsletter] Subscribers Expanded",
  /** M13: the breadcrumb's back arrow tapped, collapsing the expanded
   *  subscriber list back to the compact card. Properties: { comedianId }.
   *  Browser-back collapses (the URL's `subscribers` param falling away
   *  without this handler running) are deliberately NOT tracked — effect-
   *  based tracking on `subscribersOpen` would false-fire on a
   *  `?subscribers=open` deep-link mount, which is not a collapse action. */
  SUBSCRIBERS_COLLAPSED = "[Comedian Dashboard - Newsletter] Subscribers Collapsed",
  /** Calendar/list toggle on an overview section (M25: `mode`'s grid value
   *  renamed "card" → "calendar" — same event name/shape). Properties:
   *  { comedianId, section: "drafts" | "planned" | "upcoming" |
   *  "past_issues", mode: "calendar" | "list" }.
   *  RETIRED as of M27 — the per-section calendar/list toggle is gone (the
   *  list/table is the only inline view; the calendar moved to the
   *  action-bar's full-screen overlay, see CALENDAR_OPENED). The enum member
   *  stays only because `mixpanel.types.ts` edits are append-only. */
  SECTION_VIEW_MODE_CHANGED = "[Comedian Dashboard - Newsletter] Section View Mode Changed",
  /** M23: rows-per-page select on a paginated overview section (Scheduled
   *  tab today — was "planned" before that tab's refactor). Properties:
   *  { comedianId, section: "scheduled", page_size: 10 | 15 | 25 | 50 }. */
  SECTION_PAGE_SIZE_CHANGED = "[Comedian Dashboard - Newsletter] Section Page Size Changed",
  /** M17: the send-parity Preview dialog opened. Properties: { comedianId,
   *  source? } — `source` ("compose" | "slot_row" | "sent_row" | "draft_row",
   *  typed as `NewsletterPreviewSource` in apps/web's EmailPreviewDialog) says
   *  which surface opened it: the compose action bar's Preview trigger, a
   *  draft/scheduled slot's "⋮" View item, a sent row's row-click or "⋮"
   *  View item, or a plain Drafts-tab row's "⋮" Preview item. Draft/slot
   *  ROW clicks open compose, not the preview — only sent rows still
   *  preview on row-click. Historical un-sourced fires are all compose. */
  PREVIEW_OPENED = "[Comedian Dashboard - Newsletter] Preview Opened",
  /** M16: the compose action bar's Save or Save & close button clicked — a
   *  manual, immediate save distinct from silent autosave. Properties:
   *  { comedianId, action: "save" | "save_close" }. */
  COMPOSE_SAVE_CLICKED = "[Comedian Dashboard - Newsletter] Compose Save Clicked",
  /** M18: the send-confirm dialog's "Schedule" action confirmed — the draft
   *  is stamped with `scheduledFor` and NOT converted into a sent issue (no
   *  network mutation — see the drafts-store docblock's M8 seam). Properties:
   *  { comedianId, scheduledFor, scheduledTime, daysAhead, source? } —
   *  `scheduledTime` is "HH:mm" or null for a date-only schedule; `source`
   *  (M28) is `"preview"` when the date was picked from the row-click preview
   *  dialog's Schedule popover (compose's own flow keeps firing un-sourced). */
  ISSUE_SCHEDULED = "[Comedian Dashboard - Newsletter] Issue Scheduled",
  /** M18: an already-scheduled draft's date changed via the compose chrome's
   *  "Change date" control. Same properties as ISSUE_SCHEDULED, plus an
   *  optional `source` (M27): `"calendar_drag"` when the reschedule came from
   *  dragging a scheduled draft's chip to another day on the overlay
   *  calendar; `"calendar_popover"` when it came from the
   *  calendar's entry-details sidebar's Change date panel (relocated there
   *  from the retired chip popover — the value stays for analytics
   *  continuity; also fires for a first-time schedule set
   *  there — the calendar never fires ISSUE_SCHEDULED) — the compose flow
   *  keeps firing this un-sourced. The source vocabulary is typed as
   *  `NewsletterScheduleChangeSource` (messaging's
   *  `drafts/newsletter-drafts.ts`) — `satisfies` it at call sites. */
  SCHEDULE_CHANGED = "[Comedian Dashboard - Newsletter] Schedule Changed",
  /** M18: an already-scheduled draft's "Remove" control cleared its
   *  `scheduledFor`, leaving it a plain draft. Properties: { comedianId }. */
  SCHEDULE_CLEARED = "[Comedian Dashboard - Newsletter] Schedule Cleared",
  /** M4 (feedback B1-3a): the post-schedule celebration modal rendered —
   *  fires once per mount (one-shot Tab state, so exactly once per compose
   *  schedule confirm; refresh/back never replay it). Properties:
   *  { comedianId, scheduledFor, scheduledTime, daysAhead } — same shapes
   *  as ISSUE_SCHEDULED, which keeps firing unchanged at confirm time. */
  SCHEDULE_CELEBRATION_VIEWED = "[Comedian Dashboard - Newsletter] Schedule Celebration Viewed",
  /** Status polish: a planned draft marked "ready to send" (`approvedAt`
   *  stamped). Properties: { comedianId, source: "planned_queue" | "compose"
   *  | "preview", series_id: string | null, slot_date: string | null } —
   *  M28 RE-ATTRIBUTES every fire from the row-click preview dialog's footer
   *  to `"preview"`; `"planned_queue"` fires cease entirely (the row menu
   *  never approved — the preview dialog's footer always owned this action,
   *  it was just mislabeled). */
  DRAFT_APPROVED = "[Comedian Dashboard - Newsletter] Draft Approved",
  /** Status polish: an approved draft's approval cleared. Same properties as
   *  DRAFT_APPROVED. */
  DRAFT_UNAPPROVED = "[Comedian Dashboard - Newsletter] Draft Unapproved",
  /** Status polish: the Add-to-series picker revealed — fires at picker
   *  mount, once per open, from EITHER host (the compose action-bar dialog
   *  or the Send-or-Schedule modal's series branch).
   *  Properties: { comedianId, series_count, occupied_slot_count }. */
  ADD_TO_SERIES_OPENED = "[Comedian Dashboard - Newsletter] Add To Series Opened",
  /** Status polish: the compose session's draft attached to a series slot
   *  from either picker host. Properties: { comedianId, series_id,
   *  slot_date, displaced_draft: boolean (an occupying draft was detached),
   *  was_scheduled: boolean (the session had an explicit date, now cleared),
   *  source: "action_bar" | "send_modal" (M13 — which of the picker's two
   *  hosts fired), displaced_approved: boolean (M13 — the detached occupant
   *  was approved) }. */
  DRAFT_ADDED_TO_SERIES = "[Comedian Dashboard - Newsletter] Draft Added To Series",
  /** M24: a Drafts/Scheduled/Sent/Series list filter committed a non-empty
   *  state — search (debounced, non-empty commit only), a date range (both
   *  ends picked), or a series checked. Properties: { comedianId, section:
   *  "drafts" | "scheduled" | "sent" | "series" (pre-refactor fires carried
   *  "planned"), filter_type: "search" | "date_range" | "series",
   *  series_count? } — `query_length` (never the raw query text)
   *  accompanies a `filter_type: "search"` fire instead; `series_count` is
   *  the number of series checked after the toggle. */
  LIST_FILTER_APPLIED = "[Comedian Dashboard - Newsletter] List Filter Applied",
  /** M24: a list filter cleared back to inactive — search emptied, the date
   *  range's Clear, a series unchecked down to none, a single removed chip,
   *  or the "all" filters reset (the no-matches empty state's "Clear
   *  filters" CTA, or the chip row's own "Clear all"). Properties:
   *  { comedianId, section, filter_type: "search" | "date_range" | "series" |
   *  "all" }. */
  LIST_FILTER_CLEARED = "[Comedian Dashboard - Newsletter] List Filter Cleared",
  /** M26: a Suggestion-card CTA clicked on the overview stage. `state` is the
   *  journey state that was showing; slot-carrying states also report the
   *  slot's series + date. The create_first state does NOT fire this — it
   *  funnels through the existing Create choke point (NUDGE_CTA_CLICKED,
   *  tier "none") per D68. Properties: { comedianId, state: "create_series" |
   *  "start_draft" | "resume_draft" | "open_scheduled" | "get_ahead",
   *  series_id?, slot_date? }. */
  SUGGESTION_CTA_CLICKED = "[Comedian Dashboard - Newsletter] Suggestion CTA Clicked",
  /** M27: the "View calendar" button (now in the tabs row's actions slot)
   *  opened the full-screen overlay calendar. Properties: { comedianId,
   *  active_tab: "drafts" | "scheduled" | "sent" | "series" (pre-refactor
   *  fires carried "planned"), slot_count, draft_count, sent_count,
   *  filters_active } — the three counts are the FILTERED arrays the overlay
   *  plots (matching whatever the action bar's search/date/series filters
   *  currently narrow to), and `filters_active` mirrors
   *  `hasActiveListFilters`. */
  CALENDAR_OPENED = "[Comedian Dashboard - Newsletter] Calendar Opened",
  /** A sent issue duplicated into a fresh draft from a Sent row's "⋮" menu
   *  (Sent tab or the Series tab's grouped history) or the row-click preview
   *  dialog's "Duplicate as draft" footer button (M28). Content only travels
   *  (subject " copy" + doc — see the Tab's `handleDuplicateIssue` →
   *  `writer.create`); fires at click,
   *  like DRAFT_DUPLICATED. Properties: { comedianId, source? } — `source`
   *  is `"preview"` from the preview dialog; menu fires stay un-sourced. */
  ISSUE_DUPLICATED = "[Comedian Dashboard - Newsletter] Issue Duplicated",
  /** M29: an "Add to calendar" button clicked in `AddToCalendarButtons` —
   *  fires once per click, whether or not the calendar app / .ics download
   *  actually completed (fire-and-forget, see the component docblock).
   *  Properties: { comedianId, client: "google" | "apple" | "outlook",
   *  surface: "newsletter" | "automations", frequency: CadenceFrequency,
   *  lead_time: ReminderLeadTimeId, series_id? } — `series_id` is omitted
   *  for an unsaved "new" series editor session. Replaces the retired
   *  intent-only `reminderChannel` email/SMS picker (see CADENCE_SET's
   *  note). */
  SERIES_CALENDAR_ADDED = "[Comedian Dashboard - Newsletter] Series Added To Calendar",
  /** M2: the overlay calendar's docked day-preview panel opened (Variant A
   *  per designs/M2-design.html) — a day cell clicked directly, or its
   *  "+N more" button. Properties: { comedianId, day, item_count, source:
   *  "day_click" | "more_button" } — `day` is `YYYY-MM-DD`; `item_count` is
   *  every dated slot/draft/issue landing on that day (matches what the
   *  panel lists). Fires on every open, including re-clicking the
   *  already-previewed day. */
  CALENDAR_DAY_PREVIEWED = "[Comedian Dashboard - Newsletter] Calendar Day Previewed",
  /** The overlay calendar's entry-details sidebar (`EntryPreviewPanel`)
   *  opened — a chip click in the month grid, a day-preview panel row, or
   *  the undated "Needs a send date" strip; replaces the retired chip action
   *  popover. Properties: { comedianId, kind: "slot" | "draft" | "issue",
   *  status: NewsletterStatus, source: "grid_chip" | "day_panel_row" |
   *  "undated_strip" }. Fires on every selection, including re-selecting the
   *  already-open entry. */
  CALENDAR_ENTRY_PREVIEWED = "[Comedian Dashboard - Newsletter] Calendar Entry Previewed",
  /** M18: the beta banner's "Give feedback" text button clicked, opening the
   *  Sentry user-feedback form (`formTitle: "Newsletter beta feedback"`).
   *  No properties — the banner mounts without comedian context. */
  BETA_FEEDBACK_OPENED = "[Comedian Dashboard - Newsletter] Beta Feedback Opened",
}

export enum AutomationTouchpointEvents {
  /** A show's automation opt-out flipped: the whole-show switch
   *  (`scope: "show"`, `automation_id: "show-announcement"` by convention)
   *  or one row's Skip/Resume action (`scope: "recipe"`, the real recipe
   *  id). Properties: { comedianId, surface: "automations_tab", scope,
   *  automation_id, show_id, excluded }. One event per show id written. */
  SHOW_OPT_OUT_TOGGLED = "[Comedian Dashboard - Automations] Show Opt-Out Toggled",
  /** A test email was sent from the automation composer. Properties:
   *  { comedianId, automation_id, scope: "show" | "default" }. */
  TEST_SENT = "[Comedian Dashboard - Automations] Test Sent",
}

/** The automations discovery prompt: VIEWED (once) then CTA_CLICKED or DISMISSED. */
export enum AutomationsDiscoveryEvents {
  /** Properties: { comedianId, entitlement_status, surface? }. Fires once the card's dismissal read has resolved. */
  DISCOVERY_CARD_VIEWED = "[Comedian Dashboard - Automations Discovery] Card Viewed",
  /** Properties: { comedianId, target: "automations_tab" | "plans", surface? }. */
  DISCOVERY_CARD_CTA_CLICKED = "[Comedian Dashboard - Automations Discovery] Card CTA Clicked",
  /** Properties: { comedianId }. The card never renders again for this comedian on this device. */
  DISCOVERY_CARD_DISMISSED = "[Comedian Dashboard - Automations Discovery] Card Dismissed",
}

/** Automations demand signals: the locked switch's purchase prompt, a lapsed plan's Reactivate, and the Defaults tab's recipe switches. */
export enum AutomationsPaywallEvents {
  /** A locked switch opened the purchase prompt. Properties: { comedianId, entitlement_status, automation_label }. */
  PURCHASE_GATE_OPENED = "[Comedian Dashboard - Automations] Purchase Gate Opened",
  /** The prompt's See plans clicked (links to checkout). Same properties as OPENED. */
  PURCHASE_GATE_CHECKOUT_CLICKED = "[Comedian Dashboard - Automations] Purchase Gate Checkout Clicked",
  /** The prompt's "Not now" clicked. Same properties as OPENED. */
  PURCHASE_GATE_DISMISSED = "[Comedian Dashboard - Automations] Purchase Gate Dismissed",
  /** A lapsed plan's Reactivate clicked (opens the card modal, not checkout). Properties: { comedianId }. */
  REACTIVATE_CLICKED = "[Comedian Dashboard - Automations] Reactivate Clicked",
  /** A Defaults-tab recipe switch flipped. Properties: { comedianId, automation_id, enabled,
   *  scope: "recipe" | "all" }. The "All automations" switch fires one event per recipe it flips. */
  RECIPE_TOGGLED = "[Comedian Dashboard - Automations] Recipe Toggled",
}

export enum MessageHistoryEvents {
  OPENED = "[Comedian Dashboard - Message History] Opened",
  MESSAGE_VIEWED = "[Comedian Dashboard - Message History] Message Viewed",
  SEND_AGAIN_CLICKED = "[Comedian Dashboard - Message History] Send Again Clicked",
  EDIT_COPY_CLICKED = "[Comedian Dashboard - Message History] Edit Copy Clicked",
  CANCEL_SEND_CLICKED = "[Comedian Dashboard - Message History] Cancel Send Clicked",
  VIEW_TOGGLED = "[Comedian Dashboard - Message History] View Toggled",
  CHART_METRIC_SWAPPED = "[Comedian Dashboard - Message History] Chart Metric Swapped",
  CHART_DATA_SOURCE_TOGGLED = "[Comedian Dashboard - Message History] Chart Data Source Toggled",
  CHART_RENDER_MODE_TOGGLED = "[Comedian Dashboard - Message History] Chart Render Mode Toggled",
  CARD_RENDER_MODE_TOGGLED = "[Comedian Dashboard - Message History] Card Render Mode Toggled",
  METRIC_CARD_METRIC_CHANGED = "[Comedian Dashboard - Message History] Metric Card Metric Changed",
  METRIC_CARD_GROWTH_TOGGLED = "[Comedian Dashboard - Message History] Metric Card Growth Toggled",
  METRIC_CARD_GROWTH_DISPLAY_CHANGED = "[Comedian Dashboard - Message History] Metric Card Growth Display Changed",
  /** Content Card block's source PillGroup ("My videos" / "Links") toggled.
   *  Properties: { source }. */
  CONTENT_CARD_SOURCE_TOGGLED = "[Comedian Dashboard - Message History] Content Card Source Toggled",
  /** Show block's List-layout grouping toggle (Month / Venue) changed.
   *  Properties: { groupByVenue }. */
  SHOW_CARD_GROUPING_TOGGLED = "[Comedian Dashboard - Message History] Show Card Grouping Toggled",
  /** A pasted link finished (or failed) its OpenGraph unfurl.
   *  Properties: { provider, unfurl_status }. */
  CONTENT_CARD_LINK_UNFURLED = "[Comedian Dashboard - Message History] Content Card Link Unfurled",
  /** A link slot was moved via drag or the move-up/down buttons.
   *  Properties: { layout }. */
  CONTENT_CARD_LINKS_REORDERED = "[Comedian Dashboard - Message History] Content Card Links Reordered",
  /** A link card's snapshot was manually overridden in the editor.
   *  Properties: { provider, field: "title" | "thumbnail" }. */
  CONTENT_CARD_LINK_DETAILS_EDITED = "[Comedian Dashboard - Message History] Content Card Link Details Edited",
  /** Links-mode layout PillGroup (list/grid) toggled.
   *  Properties: { layout }. */
  CONTENT_CARD_LINKS_LAYOUT_CHANGED = "[Comedian Dashboard - Message History] Content Card Links Layout Changed",
}

export enum EmailImportEvents {
  MODAL_OPENED = "[Comedian Dashboard - Email Import] Modal Opened",
  PASTE_SUBMITTED = "[Comedian Dashboard - Email Import] Paste Submitted",
  SUCCEEDED = "[Comedian Dashboard - Email Import] Succeeded",
  FAILED = "[Comedian Dashboard - Email Import] Failed",
  APPLIED = "[Comedian Dashboard - Email Import] Applied to Canvas",
}

export enum DashboardContentManagerEvents {
  // Video list management
  PUBLISH_TOGGLED = "[Comedian Dashboard - Content Manager] Publish Toggled",
  PUBLISH_TOGGLE_FAILED = "[Comedian Dashboard - Content Manager] Publish Toggle Failed",
  MAKE_FEATURED = "[Comedian Dashboard - Content Manager] Make Featured",
  MAKE_FEATURED_FAILED = "[Comedian Dashboard - Content Manager] Make Featured Failed",
  VIDEO_SHARED = "[Comedian Dashboard - Content Manager] Video Shared",
  VIDEO_VIEWED = "[Comedian Dashboard - Content Manager] Video Viewed",

  // Video upload
  VIDEO_UPLOAD_SUBMITTED = "[Comedian Dashboard - Content Manager] Video Upload Submitted",
  VIDEO_UPLOAD_SUCCEEDED = "[Comedian Dashboard - Content Manager] Video Upload Succeeded",
  VIDEO_UPLOAD_FAILED = "[Comedian Dashboard - Content Manager] Video Upload Failed",

  // Content access / pricing
  ACCESS_TYPE_SELECTED = "[Comedian Dashboard - Content Manager] Access Type Selected",
  STRIPE_SETUP_INITIATED = "[Comedian Dashboard - Content Manager] Stripe Setup Initiated",
  SUBSCRIPTION_CREATED = "[Comedian Dashboard - Content Manager] Subscription Created",
  SUBSCRIPTION_CREATION_FAILED = "[Comedian Dashboard - Content Manager] Subscription Creation Failed",

  // Bulk video actions
  BULK_PUBLISHED = "[Comedian Dashboard - Content Manager] Bulk Published",
  BULK_UNPUBLISHED = "[Comedian Dashboard - Content Manager] Bulk Unpublished",
  BULK_UPLOAD_MENU_OPENED = "[Comedian Dashboard - Content Manager] Bulk Upload Menu Opened",
  BULK_UPLOAD_OPTION_CLICKED = "[Comedian Dashboard - Content Manager] Bulk Upload Option Clicked",
  BULK_UPLOAD_FILES_ADDED = "[Comedian Dashboard - Content Manager] Bulk Upload Files Added",
  VIDEOS_ADDED_TO_PODCAST = "[Comedian Dashboard - Content Manager] Videos Added to Podcast",
  VIDEOS_ADDED_TO_COLLECTION = "[Comedian Dashboard - Content Manager] Videos Added to Collection",

  // Podcast management
  PODCAST_CREATION_SUBMITTED = "[Comedian Dashboard - Content Manager] Podcast Creation Submitted",
  PODCAST_CREATED = "[Comedian Dashboard - Content Manager] Podcast Created",
  PODCAST_CREATION_FAILED = "[Comedian Dashboard - Content Manager] Podcast Creation Failed",
  PODCAST_EDIT_SUBMITTED = "[Comedian Dashboard - Content Manager] Podcast Edit Submitted",
  PODCAST_UPDATED = "[Comedian Dashboard - Content Manager] Podcast Updated",
  PODCAST_UPDATE_FAILED = "[Comedian Dashboard - Content Manager] Podcast Update Failed",
  EPISODE_REMOVED_FROM_PODCAST = "[Comedian Dashboard - Content Manager] Episode Removed from Podcast",

  // Special pricing
  SPECIAL_PRICING_EDIT_SUBMITTED = "[Comedian Dashboard - Content Manager] Special Pricing Edit Submitted",
  SPECIAL_PRICING_UPDATED = "[Comedian Dashboard - Content Manager] Special Pricing Updated",
  SPECIAL_PRICING_UPDATE_FAILED = "[Comedian Dashboard - Content Manager] Special Pricing Update Failed",
}

export enum CrossPostComposerEvents {
  PUBLISH_SUCCEEDED = "[Cross-Post Composer] Publish Succeeded",
  PUBLISH_PARTIAL_FAILED = "[Cross-Post Composer] Publish Partial Failed",
}

export enum VenueEvents {
  OPENED_VENUE_CHECKOUT_MODAL = "[Venue Pages] Opened Venue Subscribe Modal or Drawer",
  FOLLOWED_VENUE = "[Venue Pages] Followed Venue",
  UNFOLLOWED_VENUE = "[Venue Pages] Unfollowed Venue",
  VENUE_VIDEO_PLAYED = "[Venue Pages] Venue Video Started Playing",
  VENUE_VIDEO_PAUSED = "[Venue Pages] Venue Video Paused",
  VENUE_VIDEO_ENDED = "[Venue Pages] Venue Video Ended",
  VENUE_SEARCH_NO_RESULTS = "[Venue Pages] Venue Search - No Results",
}

export enum VenuesEvents {
  VENUES_LOADED = "[Venues Directory] Venues Loaded",
  LOCATION_CHANGED = "[Venues Directory] Location Changed",
  SEARCH_VENUES = "[Venues Directory] Search Venues",
  VENUE_CLICKED = "[Venues Directory] Venue Clicked",
  LOCATION_DETECTED = "[Venues Directory] Location Auto-Detected",
}
export enum VenueManagerShowsEvents {
  COMEDIAN_SEARCH_NO_RESULTS = "[Venue Manager - Shows] Comedian Search - No Results",
  ATTEMPTED_CREATING_NEW_COMEDIAN_FAILURE = "[Venue Manager - Shows] Comedian Search - Attempted Creating New Comedian But Failed",
  CREATED_NEW_COMEDIAN = "[Venue Manager - Shows] Comedian Search - Created New Comedian successfully",
  CANCELED_CREATING_NEW_COMEDIAN = "[Venue Manager - Shows] Comedian Search - Canceled Creating a new Comedian",
  COMEDIAN_SELECTED = "[Venue Manager - Shows] Comedian Selected",
  COMEDIAN_PHOTO_UPLOADED = "[Venue Manager - Shows] Comedian Photo Uploaded",
  COMEDIAN_PHOTO_SAVED = "[Venue Manager - Shows] Comedian Photo Saved",
  COMEDIAN_PHOTO_SKIPPED = "[Venue Manager - Shows] Comedian Photo Skipped",
  TOUR_DATE_UPDATE_SUCCESSFUL = "[Venue Manager - Shows] Tour Date Update Successful",
  TOUR_DATE_UPDATE_FAILED = "[Venue Manager - Shows] Tour Date Update Failed",
  TOUR_DATE_DELETED = "[Venue Manager - Shows] Tour Date Deleted",
  TOUR_DATE_DELETION_FAILED = "[Venue Manager - Shows] Tour Date Deletion Failed",
  TOUR_DATE_EDIT_CLICKED = "[Venue Manager - Shows] Tour Date Edit Clicked",
  GROUP_OF_SHOWS_LINK_CLICKED = "[Venue Manager - Shows] Group of Shows Link Clicked",
  TOUR_DATE_SOLD_OUT_CLICKED = "[Venue Manager - Shows] Tour Date Sold Out Clicked",
  TOUR_DATE_LOW_TICKETS_CLICKED = "[Venue Manager - Shows] Tour Date Low Tickets Clicked",
  ADD_SHOW_CLICKED = "[Venue Manager - Shows] Add Show Clicked",
  CLICKED_GO_BACK = "[Venue Manager - Shows] Clicked Go Back",
  // Fired when a venue manager dismisses ("Got it") the one-time banner telling
  // them the comedian lineup moved to the bottom of the classic show dashboard.
  // The banner stops appearing after 3 dismissals (tracked per user in
  // localStorage). Properties: { showId, venuePageId }.
  COMEDIANS_MOVED_BANNER_DISMISSED = "[Venue Manager - Shows] Comedians Moved-Down Banner Dismissed",
  // Fired when a venue manager opens a show's box office from the Box Office
  // day list — the door's own entry point, distinct from the "Launch box
  // office" button inside the show dashboard's iframe. `day` says whether the
  // list is being used on the night ("Today") or to prepare ("Tomorrow", or
  // the weekday of a date loaded by "See more dates").
  // Properties: { showId, venuePageId, day }.
  BOX_OFFICE_OPENED = "[Venue Manager - Shows] Box Office Opened",
  // Fired when a venue manager clicks "See more dates" on the Box Office day
  // list, which loads the next week below the days already shown. Shows how
  // often a seller looks past tomorrow from the door.
  // Properties: { venuePageId, addedWeekCount } — the weeks loaded after the click.
  BOX_OFFICE_MORE_DATES_SHOWN = "[Venue Manager - Shows] Box Office More Dates Shown",
  // Fired once per visit to a page of the native show surface (the pages ported
  // out of the Tixologi iframe, which never reported page views): which show
  // pages managers use. `page` is the page's key — dashboard, attendees, comped,
  // compedSend, transactions, scanned, scanner, gates, lottery, analytics,
  // boxOffice. Properties: { page, showId, tixologiEventId, venuePageId?,
  // comedianId? } — the venue or the comedian the show is managed as.
  LOADED_SHOW_PAGE = "[Venue Manager - Shows] Loaded Show Page",
}

export enum VenueDashboardEvents {
  // Navigation
  // Venue-surface twin of DashboardEvents.COMEDIAN_CLICK_DASHBOARD_SIDEBAR.
  // The sidebar UI is shared between the comedian and venue dashboards, so each
  // surface fires its own named event (see
  // docs/research/mixpanel-event-source-of-truth-audit.md).
  CLICKED_SIDEBAR = "[Venue Dashboard] Clicked Sidebar Item",

  // Insights Dashboard Events
  LOADED_INSIGHTS_DASHBOARD = "[Venue Dashboard - Insights] Loaded Insights Dashboard",
  CLICKED_TICKETS_SOLD_METRIC_CARD = "[Venue Dashboard - Insights] Clicked Tickets Sold Metric Card",
  CLICKED_REVENUE_METRIC_CARD = "[Venue Dashboard - Insights] Clicked Revenue Metric Card",
  CLICKED_AVG_TICKET_PRICE_METRIC_CARD = "[Venue Dashboard - Insights] Clicked Avg Ticket Price Metric Card",
  CLICKED_TICKET_CLICKS_METRIC_CARD = "[Venue Dashboard - Insights] Clicked Ticket Clicks Metric Card",
  CLICKED_FOLLOWERS_METRIC_CARD = "[Venue Dashboard - Insights] Clicked Followers Metric Card",
  CHANGED_INSIGHTS_TIME_RANGE = "[Venue Dashboard - Insights] Changed Time Range",
  CLICKED_MANAGE_SHOWS_FROM_INSIGHTS = "[Venue Dashboard - Insights] Clicked Manage Shows Button",

  // Event Performance Table Events
  LOADED_EVENT_PERFORMANCE_TABLE = "[Venue Dashboard - Events] Loaded Event Performance Table",
  CHANGED_EVENT_VIEW_MODE = "[Venue Dashboard - Events] Changed Event View Mode",
  CHANGED_EVENT_TIME_RANGE = "[Venue Dashboard - Events] Changed Event Time Range",
  SEARCHED_EVENTS = "[Venue Dashboard - Events] Searched Events",
  SORTED_EVENTS_TABLE = "[Venue Dashboard - Events] Sorted Events Table",
  SELECTED_EVENT_ROW = "[Venue Dashboard - Events] Selected Event Row",
  SELECTED_ALL_EVENT_ROWS = "[Venue Dashboard - Events] Selected All Event Rows",
  CLICKED_EVENT_DETAILS = "[Venue Dashboard - Events] Clicked Event Details",
  CLICKED_BACK_TO_TABLE = "[Venue Dashboard - Events] Clicked Back to Table",
  EXPORTED_EVENTS_CSV = "[Venue Dashboard - Events] Exported Events CSV",
  CLEARED_EVENT_SEARCH = "[Venue Dashboard - Events] Cleared Event Search",

  EXPORTED_FANS_CSV = "[Venue Dashboard - Fans] Exported Fans CSV",
  EXPORTED_WAITLIST_CSV = "[Venue Dashboard - Fans] Exported Waitlist CSV",
  EXPORTED_SUBSCRIBERS_CSV = "[Venue Dashboard - Fans] Exported Subscribers CSV",

  // Settings → Payments. Properties: { venuePageId, alreadyStarted }.
  CLICKED_CONNECT_STRIPE = "[Venue Dashboard - Settings] Clicked Connect Stripe",
}

// The venue-owned email composer at /v/[venueSlug]/dashboard/messaging
// (gated by `emails_for_venues_beta`). Every event carries
// `venuePageId`; see the trackMessagingEvent helper in
// apps/web/components/dashboard/venue-manager/messaging/analytics.ts for the
// property bags. Design toggles share ONE parameterized event (an `option`
// property) instead of an enum member per toggle.
export enum VenueMessagingEvents {
  // Messaging page (jobs + contact-lists overview)
  VIEWED_MESSAGING_PAGE = "[Venue Manager - Messaging] Viewed Messaging Page",
  CLICKED_NEW_MESSAGE = "[Venue Manager - Messaging] Clicked New Message",
  OPENED_JOB_PREVIEW = "[Venue Manager - Messaging] Opened Job Preview",
  CLICKED_EDIT_JOB = "[Venue Manager - Messaging] Clicked Edit Job",
  DELETED_JOB = "[Venue Manager - Messaging] Deleted Scheduled Job",
  DELETE_JOB_FAILED = "[Venue Manager - Messaging] Delete Job Failed",
  // Fired from the LEGACY marketing page's beta notice (MarketingClient) —
  // a beta user clicking through to the new tool instead of the iframe.
  CLICKED_BETA_NOTICE_LINK = "[Venue Manager - Messaging] Clicked Beta Notice Link",
  CREATED_CONTACT_LIST = "[Venue Manager - Messaging] Created Contact List",
  CREATE_CONTACT_LIST_FAILED = "[Venue Manager - Messaging] Create Contact List Failed",
  DELETED_CONTACT_LIST = "[Venue Manager - Messaging] Deleted Contact List",

  // Compose flow (funnel: started → completed step 1 → 2 → submitted)
  STARTED_COMPOSE = "[Venue Manager - Messaging] Started Compose",
  COMPLETED_COMPOSE_STEP = "[Venue Manager - Messaging] Completed Compose Step",
  CLICKED_COMPOSE_BACK = "[Venue Manager - Messaging] Clicked Compose Back",
  EXITED_COMPOSE = "[Venue Manager - Messaging] Exited Compose",

  // Email builder (step 1) interactions
  TOGGLED_DESIGN_OPTION = "[Venue Manager - Messaging] Toggled Design Option",
  CHANGED_ACCENT_COLOR = "[Venue Manager - Messaging] Changed Accent Color",
  RESET_ACCENT_COLOR = "[Venue Manager - Messaging] Reset Accent Color",
  UPLOADED_HERO_IMAGE = "[Venue Manager - Messaging] Uploaded Hero Image",
  CHANGED_FEATURED_EVENTS = "[Venue Manager - Messaging] Changed Featured Events",
  // Fired once per resolved title search in a composer show picker (step-1
  // featured events, step-2 waitlist / ticket buyers) — how often managers
  // reach past the initial 30-show window, and whether they find anything.
  // Properties: { venuePageId, picker: "featured" | "waitlist" | "ticket_buyers",
  // resultCount, hasTitle, hasDateRange }.
  SEARCHED_SHOWS = "[Venue Manager - Messaging] Searched Shows",

  // Audience (step 2)
  TOGGLED_AUDIENCE_SEGMENT = "[Venue Manager - Messaging] Toggled Audience Segment",

  // Submit — carries the design/audience/delivery snapshot
  SUBMITTED_EMAIL = "[Venue Manager - Messaging] Submitted Email",
  SUBMIT_EMAIL_FAILED = "[Venue Manager - Messaging] Submit Email Failed",
  SAVED_JOB_EDIT = "[Venue Manager - Messaging] Saved Job Edit",
  SAVE_JOB_EDIT_FAILED = "[Venue Manager - Messaging] Save Job Edit Failed",
}

export enum TixologiEvents {
  // Fired when an eligible user switches between the new ("green-zone") and the
  // classic tixologi ticketing UI via the TixologiModeToggle. Properties:
  // { Mode: "new" | "classic", Source: <surface that fired the toggle> }.
  TOGGLED_UI_MODE = "[Tixologi] Toggled UI Mode",
  // Fired once per iframe session from TixologiIframe's auth-injection pass with the
  // EFFECTIVE view the iframe was given — the steady-state counterpart of TOGGLED_UI_MODE.
  // Properties: LoadedUiModeProps (below). Temporary, retired with the `tixologi_green_zone`
  // gate — semantics in docs/specs/statsig.md → `tixologi_green_zone`.
  LOADED_UI_MODE = "[Tixologi] Loaded UI Mode",
}

/**
 * Which tixologi page the iframe loaded — the `Surface` property on
 * TixologiEvents.LOADED_UI_MODE, derived from the iframe URL path. Spelled like the
 * toggle's `Source` values (`show_dashboard`, `marketing`) so both events break down
 * on one vocabulary. `native_show` is no iframe page: the show route rendered
 * natively (fired once per route session by the host shell), and the `Source` of the
 * toggle in that route's header.
 */
export const TixologiSurface = {
  SHOW_DASHBOARD: "show_dashboard",
  NEW_TICKET: "new_ticket",
  MARKETING: "marketing",
  CREATE_EVENT: "create_event",
  NATIVE_SHOW: "native_show",
  OTHER: "other",
} as const;
export type TixologiSurface =
  (typeof TixologiSurface)[keyof typeof TixologiSurface];

/** Properties of TixologiEvents.LOADED_UI_MODE. */
export type LoadedUiModeProps = {
  Mode: "new" | "classic";
  Eligible: boolean;
  Scope: "venue" | "comedian";
  Surface: TixologiSurface;
  Email?: string;
  VenuePageId?: string;
  VenueName?: string;
  VenueSlug?: string;
  ComedianId?: string;
};

export enum SpecialEvents {
  SPECIAL_INITIALIZED = "Special Initialized",
  SPECIAL_CLICKED_PLAY = "Clicked Play",
  SPECIAL_CLICKED_PAUSE = "Clicked Pause",
  SPECIAL_SEEKING = "Seeking",
  SPECIAL_PAGE_LOADED = "Loaded Special Page",
  REACTION_BUTTON_CLICKED = "Special Reaction Button Clicked",
  REACTION_SUBMITTED = "User Special Reaction Submitted",
}

export enum BundleEvents {
  BUNDLE_PAGE_LOADED = "Loaded Bundle Page",
}

export enum VideoEvents {
  VIDEO_METADATA_LOADED = "Video Metadata Loaded",
  VIDEO_SESSION_STARTED = "Video Session Started",
  VIDEO_VIEWED_3S = "Video Viewed for 3 Seconds",
  VIDEO_VIEWED_10S = "Video Viewed for 10 Seconds",
  VIDEO_VIEWED_30S = "Video Viewed for 30 Seconds",
  VIDEO_SESSION_ENDED = "Video Session Ended",
  VIDEO_STALLED = "Video Stalled",
  VIDEO_ERROR = "Video Error",
  AUTOPLAY_QUEUE_LOADED = "Autoplay Queue Loaded",
  SHOWED_PLAY_NEXT_OVERLAY = "Showed Play Next Overlay",
  PLAY_NEXT_VIDEO_AUTO = "Play Next Video Auto",
  PLAY_NEXT_VIDEO = "Play Next Video",
  CANCEL_PLAY_NEXT_VIDEO = "Cancel Play Next Video",
  CLICK_SUGGESTED_VIDEO = "Clicked Suggested Video",
  CLICKED_TICKET_LINK = "Clicked Ticket Link from Video Overlay",
  CLICKED_ALL_TICKETS = "Clicked All Tickets from Video Overlay",
  CLICKED_DISMISS_TICKETS = "Clicked Dismiss Tickets Overlay",
  CLICKED_DESCRIPTION = "Clicked description on video card",
  SHOWED_TICKETS_OVERLAY = "Showed Tickets Overlay",
  NO_TICKETS_AVAILABLE_FOR_OVERLAY = "No Tickets Available for Overlay",
  NO_ZIPCODE_AVAILABLE_FOR_OVERLAY = "No Zipcode Available for Overlay",
  LIVESTREAM_HEARTBEAT = "Livestream Heartbeat",
  VIDEO_SKIP_FORWARD = "Video Skip Forward",
  VIDEO_SKIP_BACKWARD = "Video Skip Backward",
  VIDEO_PLAYBACK_RATE_CHANGED = "Video Playback Rate Changed",
  VIDEO_SUBTITLES_CHANGED = "Video Subtitles Changed",
  VIDEO_VOLUME_PANEL_OPENED = "Video Volume Panel Opened",
  VIDEO_FULLSCREEN_CHANGED = "Video Fullscreen Changed",
}

export enum LibraryEvents {
  LOADED_LIBRARY = "Library Loaded",
  FILTERED_BY_COMEDIAN = "Library - Filtered by Comedian",
  FILTERED_BY_ALL = "Library - Filtered by All",
  CLICKED_BREADCRUMB_LINK_TO_HOME = "Clicked Breadcrumb Link to Home",
  CLICKED_BREADCRUMB_LINK_TO_LIBRARY = "Clicked Breadcrumb Link to Library",
  CLICKED_COMEDIANS_YOU_MAY_LIKE = "Clicked Comedians You May Like",
  CLICKED_VIDEOS_CONTENT_FILTER = "Clicked Videos Content Filter",
  CLICKED_PODCASTS_CONTENT_FILTER = "Clicked Podcasts Content Filter",
  CLICKED_NEW_COMEDIAN_LINK = "Clicked New Comedian Link",
  CLICKED_SEE_VIDEOS_BUTTON = "Clicked See Videos Button",
  CLICKED_TRENDING_ARTIST = "Clicked Trending Artist",
  CLICKED_FOLLOWED_ARTIST = "Clicked Followed Artist",
  CLICKED_VIEW_ALL_ARTISTS = "Clicked View All Artists",
  CLICKED_NEXT_LIBRARY_CAROUSEL = "Clicked Next on Library Carousel",
  CLICKED_PREVIOUS_LIBRARY_CAROUSEL = "Clicked Previous on Library Carousel",
  SELECTED_LIBRARY_TAB = "Library Tab Selected",
}

export enum SearchEvents {
  CLICKED_SEARCH_ON_HEADER_LOGGED_IN = "Clicked Search on Header while logged in",
  CLICKED_SEARCH_ON_HEADER_LOGGED_OUT = "Clicked Search on Header while logged out",
  CLICKED_COMEDIAN_PILL = "Clicked Comedian Pill in Search",
  CLICKED_SPECIAL_PILL = "Clicked Special Pill in Search",
  SEARCH_RESULTS_RETURNED = "Search Results Returned",
  SEARCH_RESULTS_RETURNED_EMPTY = "Search Results Returned Empty",
  SEARCH_QUERY_ERROR = "Search Query Error",
  REALLY_LONG_SEARCH_TERM = "Really Long Search Term",
  CLICKED_COMEDIAN_FROM_SEARCH = "Clicked Comedian from Search",
  CLICKED_SPECIAL_FROM_SEARCH = "Clicked Special from Search",
  UNLOCKED_SPECIALS_LOADED = "Unlocked Specials Loaded for Search",
  ALL_COMEDIANS_LOADED = "All Comedians Loaded for Search",
  CLICKED_CLEAR_SEARCH = "Clicked Clear Search",
  NEARBY_SHOWS_LOADED = "Nearby Shows Loaded for Search",
  CLICKED_SHOW_FROM_SEARCH = "Clicked Show from Search",
  CLICKED_VIEW_ALL_NEARBY_SHOWS = "Clicked View All Nearby Shows from Search",
  CLICKED_VENUE_FROM_SEARCH = "Clicked Venue from Search",
  CLICKED_SEE_ALL_SECTION = "Clicked See All in Search Section",
  CLICKED_SEE_ALL_ON_SEARCH_CAROUSEL = "Clicked See All on Search Carousel",
  VIEWED_DISCOVER_PAGE = "Viewed Discover Page",
  CLICKED_SEE_ALL_ARTISTS_ON_DISCOVER = "Clicked See All Artists on Discover",
}

/**
 * Physical surface a search/discover interaction originated on — the `source` property on
 * SearchEvents click events. Lets a comedian/venue/special click be attributed to the search
 * overlay vs. the discover page (they share event names), and a search-open to the header vs.
 * the discover page. See docs/specs/mixpanel.md.
 */
export const SearchSurface = {
  HEADER: "header",
  SEARCH_OVERLAY: "search_overlay",
  DISCOVER_PAGE: "discover_page",
} as const;
export type SearchSurface = (typeof SearchSurface)[keyof typeof SearchSurface];

/**
 * How a user arrived on /discover — the `source` property on VIEWED_DISCOVER_PAGE. Internal
 * navigators (the mobile header search, the search-overlay "See all" carousel button) pass the
 * matching value as a `?source=` query param; a visit with no param is DIRECT.
 */
export const DiscoverEntrySource = {
  HEADER_SEARCH: "header_search",
  SEARCH_CAROUSEL: "search_carousel",
  CAMPAIGN_BANNER: "campaign_banner",
  DIRECT: "direct",
} as const;
export type DiscoverEntrySource =
  (typeof DiscoverEntrySource)[keyof typeof DiscoverEntrySource];

export enum UserSignupEvents {
  USER_SUBMITTED_VALID_ZIPCODE = "User Submitted Valid Zip Code",
  USER_DISREGARDED_ZIP_CODE_MODAL = "User Disregarded Zip Code Modal",
}

export enum SpecialsCarouselEvents {
  CLICKED_SIGN_UP_FOR_UPDATES = "Carousel CTA- Clicked Sign Up for Updates",
  CLICKED_WATCH_NOW_FREE = "Carousel CTA - Clicked Watch Now for Free",
  CLICKED_WATCH_NOW_PAID = "Carousel CTA- Clicked Watch Now for Paid",
  CLICKED_ON_SPECIAL_IMAGE = "Carousel - Clicked On Special Image",
}

export enum SpecialPageEvents {
  CLICKED_COMEDIAN_NAME_LINK = "Clicked Comedian Name Link on Special Page",
  CLICKED_COMEDIAN_NAME_LINK_CHECKOUT = "Clicked Comedian Name Link on Checkout Page",
  LOADED_PREVIEW_PAGE = "Loaded Special Preview Page",
  CLICKED_SUBSCRIBE_CTA_PREVIEW = "Clicked Subscribe CTA on Special Preview Page",
}

export enum ComedianCarouselEvents {
  CLICKED_NAVIGATE_TO_COMEDIAN_PAGE = "Comedian Carousel Carousel CTA - Clicked Visit Comedian Page",
}

export enum GenericEvents {
  VISITED_HOMEPAGE = "Visited Homepage",
  CLICKED_LETS_CHAT = "Clicked Lets Chat",
}

export enum ContentNavEvents {
  NAVIGATE_TO_FEATURED = "Clicked on Featured on Comedian Page",
  NAVIGATE_TO_PODCAST = "Clicked on Podcast on Comedian Page",
  NAVIGATE_TO_COLLECTIONS = "Clicked on Collections on Comedian Page",
  NAVIGATE_TO_CONTENT = "Clicked on Content",
  CLICKED_SHARE = "Clicked Share",
  WEB_SHARE_SUCCEEDED = "Web Share Api Call Succeeded",
  WEB_SHARE_FAILED = "Web Share Api Call Failed",
  NAVIGATE_TO_TOUR_DATES = "Clicked on Tour Dates",
  NAVIGATE_TO_BIO = "Clicked on Bio",
  NAVIGATE_TO_CONTACTS = "Clicked on Contacts",

  NAVIGATE_TO_TIP_COMEDIAN = "Clicked on Tip Comedian",
}

export enum NavbarEvents {
  NAVIGATE_TO_HOME = "Clicked on Home",
  NAVIGATE_TO_LIBRARY = "Clicked on Library",
  NAVIGATE_TO_NEARBY_SHOWS = "Clicked on Nearby Shows",
  NAVIGATE_TO_VENUES = "Clicked on Venues",
}

export enum ShowsNearbyEvents {
  LOADED_SHOWS_NEARBY_PAGE = "Loaded Shows Nearby Page",
  UPDATED_ZIPCODE = "Shows Nearby - Updated Zipcode",
  RESULTS_RETURNED = "Shows Nearby - Results Returned",
  NEW_ZIPCODE_SUBMITTED = "Shows Nearby - New Zipcode Submitted",
  UNKNOWN_ZIPCODE_FOUND = "Shows Nearby - Unknown Zipcode Found",
  NO_LOCATION_FOUND = "Shows Nearby - No Location Found",
  FILTER_ALL_COMEDIANS = "Shows Nearby - Filtered by All Comedians",
  FILTER_MY_COMEDIANS = "Shows Nearby - Filtered by My Comedians",
  FILTER_OTHER_COMEDIANS = "Shows Nearby - Filtered by Other Comedians",
  FILTER_ALL_CHECKOUT_TYPES = "Shows Nearby - Filtered by All Checkout Types",
  FILTER_FAST_CHECKOUT = "Shows Nearby - Filtered by Fast Checkout",
  FILTER_EXTERNAL_CHECKOUT = "Shows Nearby - Filtered by External Checkout",
  FILTER_DATE = "Shows Nearby - Filtered by Date",
  CLICKED_COMEDIAN_NAME_TICKET_CARD = "Shows Nearby - Clicked Comedian Name from Ticket Card",
}

export enum ShareBarEvents {
  COPIED_LINK_TO_CLIPBOARD = "Copied Link to Clipboard",
  SHARED_TO_MEDIA = "Shared to Media",
  CLOSED_SHARE_BAR = "Closed Share Bar",
}

export enum SuggestedComediansEvents {
  LOADED_SUGGESTED_COMEDIANS_PAGE = "Loaded Suggested Comedians Page",
  CLICKED_SKIP_FOR_NOW = "Clicked Skip for now",
  CLICKED_SUBSCRIBE = "Clicked Subscribe",
  CHECKED_COMEDIAN = "Checked Comedian",
  UNCHECKED_COMEDIAN = "Unchecked Comedian",
  CLICKED_SELECT_ALL = "Clicked Select All Comedians",
  CLICKED_UNSELECT_ALL = "Clicked Unselect All Comedians",
  CLICKED_SKIP = "Clicked Skip",
}

export enum CheckoutEvents {
  LOADED_CHECKOUT_PAGE = "Loaded Checkout Page",
  LOADED_PAID_CHECKOUT_PAGE = "Loaded Paid Checkout Page",
}

export enum SubscriptionPurchaseEvents {
  LOADED_TIER_LIST = "Subscription - Loaded Tier List",
  LOADED_CHECKOUT = "Subscription - Loaded Checkout",
  SUBMITTED_CHECKOUT = "Subscription - Submitted Checkout",
  CHECKOUT_INIT_ERROR = "Subscription - Checkout Initialization Error",
  CHECKOUT_CONFIRM_ERROR = "Subscription - Checkout Confirm Error",
  PURCHASE_SUCCESSFUL = "Subscription - Purchase Successful",
  PROCESSING_TIMED_OUT = "Subscription - Processing Timed Out",
}

export enum PaymentEvents {
  LOADED_PAYMENT_FORM = "Loaded Payment Form",
  FAILED_PAYMENT = "Failed Payment",
  SUCCESSFUL_PAYMENT = "Successful Payment",
  // Fired on the PARENT page when the Tixologi checkout iframe posts back a
  // completed purchase. Recording it on the parent means it lands under the
  // same Mixpanel distinct_id as the venue-page view and "Buy Tickets Clicked",
  // so the cross-origin checkout still forms one native funnel.
  TIXOLOGI_PURCHASE_COMPLETED = "Tixologi Purchase Completed",
}

/**
 * Fast Checkout widget iframe load lifecycle, recorded on the PARENT page
 * (same rationale as TIXOLOGI_PURCHASE_COMPLETED above: the checkout itself is a
 * cross-origin iframe, so parent-side recording keeps one Mixpanel distinct_id
 * across the buy click, the load outcome, and the purchase).
 *
 * Shared properties on every event: show_id, show_title, tixologi_event_id,
 * venue_id, venue_name, widget_origin, hostname, is_mobile_view, attempt
 * (1 = first open, 2+ = "Buy more tickets" reloads), retry (0 = the attempt's
 * first load, 1..MAX_LOAD_RETRIES = silent forced reloads of a dead load).
 *
 * How to interpret ready_source / the milestone triple, the timer
 * relationships, and the known blind spots live in ONE home:
 * docs/specs/tixologi-widget.md → "Load observability & the slow-load fallback".
 */
export enum FastCheckoutEvents {
  /**
   * First reveal of the widget iframe per attempt, from any signal.
   * Extra properties: ready_source ("page-ready" | "legacy-height" |
   * "load-fallback"), duration_ms (current load cycle → reveal),
   * total_wait_ms (buyer-experienced wait across all retry cycles),
   * ms_to_iframe_load / ms_to_widget_ready / ms_to_first_height (null if that
   * milestone never happened this cycle), timed_out_first (a load timeout
   * fired before this reveal — the "slow but recovered" cohort).
   */
  WIDGET_LOADED = "Fast Checkout - Widget Loaded",
  /**
   * A load cycle spent its 3s window with no real-content signal from the
   * widget. Fires once per cycle: a dead load emits up to 1 + MAX_LOAD_RETRIES
   * of these per attempt (will_retry tells them apart); only the final one
   * (will_retry=false, buyer sees the fallback panel) mirrors to Sentry.
   * Extra properties: elapsed_ms, iframe_load_fired, widget_ready_fired,
   * height_seen, will_retry.
   */
  WIDGET_LOAD_TIMEOUT = "Fast Checkout - Widget Load Timeout",
  /**
   * The buyer closed the checkout modal before the widget ever proved real
   * content — the blank-iframe failure as experienced in the wild.
   * Extra properties: elapsed_ms, total_wait_ms, iframe_load_fired,
   * widget_ready_fired, height_seen, timeout_fired.
   */
  WIDGET_CLOSED_BEFORE_READY = "Fast Checkout - Widget Closed Before Ready",
  /**
   * The buyer clicked the slow-load fallback's "Open checkout in a new tab"
   * escape hatch. Shared properties only.
   */
  WIDGET_OPENED_IN_NEW_TAB = "Fast Checkout - Opened Checkout in New Tab",
}

export enum GroupedShowsEvents {
  GROUPED_SHOWS_PAGE_LOADED = "Grouped Shows Page Loaded",
  GROUPED_SHOWS_PAGE_CLICKED_BUY_TICKETS = "Grouped Shows Page - Clicked Buy Tickets",
}

export enum NotificationPreferencesEvents {
  SUBSCRIBED_TO_NEWSLETTER = "Subscribed to Email Newsletter",
  UNSUBSCRIBED_FROM_NEWSLETTER = "Unsubscribed from Email Newsletter",
  SUBSCRIBED_TO_NEW_COMEDIANS = "Subscribed to New Comedians",
  UNSUBSCRIBED_FROM_NEW_COMEDIANS = "Unsubscribed from New Comedians",
  SUBSCRIBED_TO_NEW_SPECIALS_FROM_FOLLOWED_COMEDIANS = "Subscribed to New Specials from Followed Comedians",
  UNSUBSCRIBED_FROM_NEW_SPECIALS_FROM_FOLLOWED_COMEDIANS = "Unsubscribed from New Specials from Followed Comedians",
  SUBSCRIBED_TO_NEW_TOUR_DATES_FROM_FOLLOWED_COMEDIANS = "Subscribed to New Tour Dates from Followed Comedians",
  UNSUBSCRIBED_FROM_NEW_TOUR_DATES_FROM_FOLLOWED_COMEDIANS = "Unsubscribed from New Tour Dates from Followed Comedians",
  SUBSCRIBED_TO_NEW_SUBSCRIPTION_CONTENT = "Subscribed to New Subscription Content from Followed Comedians",
  UNSUBSCRIBED_FROM_NEW_SUBSCRIPTION_CONTENT = "Unsubscribed from New Subscription Content from Followed Comedians",
  CHANGED_COMEDIAN_NOTIFICATION_PREFERENCE = "Changed Comedian Notification Preference",
  SMS_MARKETING_OPT_OUT = "Opted Out From Global Comedian Custom Messages",
  SMS_MARKETING_OPT_IN = "Opted Back In To Global Comedian Custom Messages",
  RESPONDED_TO_COMEDIAN_SMS_MESSAGE = "User Responded to Comedian Custom Message",
}

export enum EmailEvents {
  LOADED_EMAIL_PREFERENCES_PAGE = "Loaded Email Preferences Page for Comedian",
  LOADED_EMAIL_PREFERENCES_PAGE_FOR_VENUE = "Loaded Email Preferences Page for Venue",
}

export enum WebNotificationsEvents {
  CLICKED_NOTIFICATION_BELL = "Clicked Notification Bell",
  CLICKED_ON_NOTIFICATION = "Clicked on Notification", // properties: notification type and if it's grouped yes or no + location
  CLICKED_ON_VIEW_ALL_NOTIFICATIONS = "Notification Bell - Clicked on View All Notifications",
  CLICKED_MARK_ALL_AS_READ = "Clicked Mark All As Read", // properties: location
  SWITCHED_NOTIFICATION_ORDERING_TYPE = "Changed Notification Ordering Type", // properties: type of ordering
  NAVIGATE_TO_LIBRARY_BECAUSE_NO_NOTIFICATIONS = "Navigated to Library because no notifications were found",
}

export enum FeedEvents {
  LOADED_FEED_PAGE = "Loaded Feed Page",
  CLICKED_SUBSCRIBED_VIDEO_CARD = "Clicked Subscribed on Video Feed Card",
  CLICKED_TITLE_VIDEO_CARD = "Clicked Title on Video Feed Card",
  CLICKED_VIDEO_IMAGE_VIDEO_CARD = "Clicked Video Image on Feed Video Card",
  CLICKED_COMEDIAN_NAME_VIDEO_CARD = "Clicked Comedian Name on Feed Video Card",
  HOVERED_COMEDIAN_AVATAR_VIDEO_CARD = "Hovered Comedian Avatar on Feed Video Card",
  CLICKED_COMEDIAN_AVATAR_VIDEO_CARD = "Clicked Comedian Avatar on Feed Video Card",
  CLICKED_SUGGESTED_COMEDIAN_CARD = "Clicked Suggested Comedians Card",
  CLICKED_NEXT_SUGGESTED_CAROUSEL = "Clicked Next on Suggested Comedians Carousel",
  CLICKED_PREVIOUS_SUGGESTED_CAROUSEL = "Clicked Previous on Suggested Comedians Carousel",

  // brand-moment hero + logged-out conversion surfaces
  VIEWED_FEED_HERO = "Viewed Feed Hero",
  CLICKED_FEED_HERO_CTA = "Clicked Feed Hero CTA",
  CLICKED_FEED_CONVERSION_CARD = "Clicked Feed Conversion Card",
  CLICKED_FEED_RAIL_ITEM = "Clicked Feed Rail Item",

  CLICKED_TICKETS_AND_MORE_FEATURED_COMEDIAN = "Clicked Tickets & More on Featured Comedian",
  REACHED_END_OF_FEED_PAGE = "Reached the End of a Feed Page",
  REACHED_END_OF_FEED_CONTENT = "Reached the End of the Feed Content",
  OPENED_SUBSCRIPTION_MODAL = "Opened Subscription Modal",
  // feed ad unit events
  LOADED_FEED_AD_UNIT = "Loaded Feed Ad Unit",
  CLICKED_COMEDIAN_NAME_FEED_AD_UNIT = "Clicked Comedian Name on Feed Ad Unit",
  CLICKED_SHOW_AD_UNIT = "Clicked Comedian Show on Feed Ad Unit",
  CLICKED_PREVIOUS_FEED_AD_UNIT_CAROUSEL = "Clicked Previous on Feed Ad Unit Carousel",
  CLICKED_NEXT_FEED_AD_UNIT_CAROUSEL = "Clicked Next on Feed Ad Unit Carousel",
  // feed filter events
  FEED_FILTER_CHANGE = "Feed Filter Changed",
  FEED_FILTER_SIGNIN_REDIRECT = "Feed Filter Signin Redirect",
  FEED_FILTER_OPEN = "Feed Filter Opened",
  CLICKED_VIEW_MORE_NEARBY_SHOWS = "Clicked View More Nearby Shows",
  CLICKED_VIEW_ALL_NEARBY_SHOWS = "Clicked View All Nearby Shows",
  CLICKED_PREVIOUS_CONTINUE_WATCHING_FEED_CAROUSEL = "Clicked Previous on Continue Watching Feed Carousel",
  CLICKED_NEXT_CONTINUE_WATCHING_FEED_CAROUSEL = "Clicked Next on Continue Watching Feed Carousel",
  CLICKED_PREVIOUS_TRENDING_SPECIALS_FEED_CAROUSEL = "Clicked Previous on Trending Specials Feed Carousel",
  CLICKED_NEXT_TRENDING_SPECIALS_FEED_CAROUSEL = "Clicked Next on Trending Specials Feed Carousel",
  // logged-out campaign banner events
  VIEWED_FEED_CAMPAIGN_BANNER = "Viewed Feed Campaign Banner",
  CLICKED_FEED_CAMPAIGN_BANNER = "Clicked Feed Campaign Banner",
  DISMISSED_FEED_CAMPAIGN_BANNER = "Dismissed Feed Campaign Banner",
}

export enum MerchEvents {
  CLICKED_NEXT_MERCH_CAROUSEL = "Clicked Next on Merch Carousel",
  CLICKED_PREVIOUS_MERCH_CAROUSEL = "Clicked Previous on Merch Carousel",
  NAVIGATE_TO_MERCH_STORE = "Navigate to Merch Store",
  NAVIGATE_TO_MERCH_FROM_DROPDOWN = "Navigate to Merch from Dropdown",
  NAVIGATE_TO_MERCH_STORE_SHOPIFY = "Clicked on Merch Store Shopify",
  NAVIGATE_TO_MERCH = "Clicked on Merch",
  MERCH_COMEDIAN_CLICKED = "Clicked on a comedian merch card on merch page",
  SHOPIFY_CART_CREATED = "Shopify cart created",
  SHOPIFY_ORDER_CREATED = "Shopify order created",
  SHOPIFY_ORDER_PAID = "Shopify order paid",
  SHOPIFY_CHECKOUT_CREATED = "Shopify checkout created",
}

export enum PushNotificationEvents {
  SENT_PUSH_NOTIFICATION = "Sent Push Notification",
}

export enum PaidContentEvents {
  STARTED_CREATE_TRANSACTION = "Started Create Transaction",
  TRANSACTION_CREATED_SUCCESSFULLY = "Transaction Created Successfully",
  TRANSACTION_CREATION_FAILED = "Transaction Creation Failed",
  CHECKOUT_ERROR = "Checkout Error",
  SUBMITTED_CHECKOUT_FORM = "Submitted Checkout Form",
  PAYMENT_TYPE_CHANGED = "Payment Type Changed",
  NON_USER_PURCHASE_WAITING_FOR_SIGN_IN = "Non User Purchase Setup - Waiting for Sign In",
  TRANSACTION_SETUP_SUCCESSFULLY = "Transaction Setup Successfully",
  PURCHASE_SUCCESSFUL = "Purchase Successful",
}

export enum VenuePageEvents {
  // event for each page load
  LOADED_VENUE_PAGE = "Loaded Venue Page",
  CUSTOM_LINK_PAGE_LOADED = "Venue Page - Custom Link Page Loaded",
  CUSTOM_LINK_PAGE_NOT_FOUND = "Venue Page - Custom Link Page Not Found",
  CUSTOM_LINK_PAGE_CONTENT_EMPTY = "Venue Page - Custom Link Page Content Empty",
  EXTERNAL_LINK_PAGE_LOADED = "Venue Page - External Link Page Loaded",
  // navigation events
  CLICKED_INTERNAL_LINK = "Venue Page - Clicked Internal Link",
  CLICKED_CUSTOM_INTERNAL_LINK = "Venue Page - Clicked Custom Internal Link",
  CLICKED_EXTERNAL_LINK = "Venue Page - Clicked External Link",
  CLICKED_VIEW_MORE_NAV_MENU = "Venue Page - Clicked View More on Nav Menu",
  CLICKED_CONTACT_PHONE_NUMBER = "Venue Page - Clicked Contact Phone Number",
  CLICKED_CONTACT_EMAIL = "Venue Page - Clicked Contact Email",
  HEADER_SIGN_IN_BUTTON_CLICKED = "Venue Page - Sign in Button Clicked in Header",
  HEADER_HAMBURGER_MENU_BUTTON_CLICKED = "Venue Page - Hamburger Menu Button Clicked in Header",
  HEADER_HAMBURGER_MENU_ITEM_CLICKED = "Venue Page - Hamburger Menu Item Clicked in Header",
  // show description events
  SHOW_DESCRIPTION_READ_MORE_CLICKED = "Venue Page - Show Description Read More Clicked",
  // calendar events
  CALENDAR_SHOW_CLICKED = "Venue Page - Calendar Show Clicked",
}

export enum PodcastEpisodeEvents {
  PREVIEW_STARTED = "[Podcast Episode] Preview Started",
  PREVIEW_PAUSED = "[Podcast Episode] Preview Paused",
  PREVIEW_END_SCREEN_SHOWN = "[Podcast Episode] Preview End Screen Shown",
  CTA_SHOWN = "[Podcast Episode] CTA Shown",
  CTA_CLICKED = "[Podcast Episode] CTA Clicked",
  EPISODE_CLICKED = "[Podcast Episode] Clicked",
  PUBLISH_STARTED = "[Podcast Episode] Publish Started",
  PUBLISHED = "[Podcast Episode] Published",
  PUBLISH_FAILED = "[Podcast Episode] Publish Failed",
}

export enum PodcastEvents {
  PAGE_LOADED = "[Podcast] Page Loaded",
  PODCAST_CLICKED = "[Podcast] Clicked",
  CTA_CLICKED = "[Podcast] CTA Clicked",
}

export enum CommentEvents {
  // Core comment section events
  COMMENT_SECTION_LOADED = "Comment Section Loaded",
  COMMENT_SECTION_ERROR = "Comment Section Error",

  // Comment input events
  COMMENT_INPUT_FOCUSED = "Comment Input Focused",
  COMMENT_INPUT_TYPING = "Comment Input Typing",
  COMMENT_INPUT_BLURRED = "Comment Input Blurred",

  // Comment submission events
  COMMENT_SUBMITTED = "Comment Submitted",
  COMMENT_SUBMIT_FAILED = "Comment Submit Failed",
  COMMENT_SUBMIT_RATE_LIMITED = "Comment Submit Rate Limited",
  COMMENT_VALIDATION_FAILED = "Comment Validation Failed",
  ARTIST_COMMENT_POSTED = "Artist Comment Posted",

  // Comment management events
  COMMENT_EDITED = "Comment Edited",
  COMMENT_EDIT_CANCELLED = "Comment Edit Cancelled",
  COMMENT_DELETED = "Comment Deleted",
  COMMENT_DELETE_CANCELLED = "Comment Delete Cancelled",

  // Reply events
  REPLY_BUTTON_CLICKED = "Reply Button Clicked",
  REPLY_INPUT_OPENED = "Reply Input Opened",
  REPLY_INPUT_CLOSED = "Reply Input Closed",
  REPLY_SUBMITTED = "Reply Submitted",
  REPLY_SUBMIT_FAILED = "Reply Submit Failed",

  // Comment threading events
  REPLIES_EXPANDED = "Replies Expanded",
  REPLIES_COLLAPSED = "Replies Collapsed",

  // Comment interaction events
  COMMENT_CLAP_CLICKED = "Comment Clap Clicked",
  COMMENT_CLAP_SUBMITTED = "Comment Clap Submitted",

  // Pagination and loading events
  COMMENTS_LOAD_MORE_CLICKED = "Comments Load More Clicked",
  COMMENTS_REFRESH_CLICKED = "Comments Refresh Clicked",
  COMMENTS_NEW_AVAILABLE_CLICKED = "Comments New Available Clicked",

  // Mobile-specific events
  MOBILE_COMMENT_MODAL_OPENED = "Mobile Comment Modal Opened",
  MOBILE_COMMENT_MODAL_CLOSED = "Mobile Comment Modal Closed",
  MOBILE_COMMENT_PREVIEW_CLICKED = "Mobile Comment Preview Clicked",

  // Error and edge case events
  COMMENT_AUTHENTICATION_REQUIRED = "Comment Authentication Required",
  COMMENT_FEATURE_DISABLED = "Comment Feature Disabled",
}

export enum CTA_SOURCES {
  // Comedian page CTAs
  COMEDIAN_PAGE_HERO_SUBSCRIBE = "comedian_page_hero_subscribe",
  COMEDIAN_PAGE_HERO_SEE_PLANS = "comedian_page_hero_see_plans",
  COMEDIAN_PAGE_STICKY_BAR_SUBSCRIBE = "comedian_page_sticky_bar_subscribe",
  COMEDIAN_PAGE_GUEST_LIST_SIGNUP = "comedian_page_guest_list_signup",
  COMEDIAN_PAGE_SHOW_ROW_BUY_TICKETS = "comedian_page_show_row_buy_tickets",
  COMEDIAN_PAGE_NAV_TAB_FEATURED = "comedian_page_nav_tab_featured",
  COMEDIAN_PAGE_NAV_TAB_TOUR = "comedian_page_nav_tab_tour",
  COMEDIAN_PAGE_NAV_TAB_VIDEOS = "comedian_page_nav_tab_videos",
  COMEDIAN_PAGE_NAV_TAB_ABOUT = "comedian_page_nav_tab_about",
  COMEDIAN_PAGE_NAV_TAB_CONTACTS = "comedian_page_nav_tab_contacts",
  COMEDIAN_PAGE_NAV_TAB_PODCASTS = "comedian_page_nav_tab_podcasts",
  COMEDIAN_PAGE_NAV_TAB_COLLECTIONS = "comedian_page_nav_tab_collections",
  COMEDIAN_PAGE_NAV_TAB_MERCH = "comedian_page_nav_tab_merch",
  COMEDIAN_PAGE_MERCH_CARD = "comedian_page_merch_card",
  COMEDIAN_PAGE_FEATURED_SPECIAL_CARD = "comedian_page_featured_special_card",
  // Podcast surface CTAs
  COMEDIAN_PAGE_FEATURED_PODCAST = "comedian_page_featured_podcast",
  COMEDIAN_PAGE_PODCAST_TILE = "comedian_page_podcast_tile",
  COMEDIAN_PAGE_PODCAST_EPISODE_ROW = "comedian_page_podcast_episode_row",
  COMEDIAN_PAGE_PODCAST_EPISODE_PLAY_BUTTON = "comedian_page_podcast_episode_play_button",
  COMEDIAN_PAGE_PODCAST_EPISODE_LOCKED_CTA = "comedian_page_podcast_episode_locked_cta",
  COMEDIAN_PAGE_PODCAST_PREVIEW_END_SCREEN_CTA = "comedian_page_podcast_preview_end_screen_cta",
  COMEDIAN_PAGE_PODCAST_HEADER_UNLOCK = "comedian_page_podcast_header_unlock",
  COMEDIAN_PAGE_PODCAST_TILE_UNLOCK = "comedian_page_podcast_tile_unlock",
  EPISODE_CHECKOUT_COLLECTION_UPSELL = "episode_checkout_collection_upsell",
  // Search & discover quick-subscribe CTAs
  SEARCH_RESULTS_ROW_SUBSCRIBE = "search_results_row_subscribe",
  SEARCH_TRENDING_CAROUSEL_SUBSCRIBE = "search_trending_carousel_subscribe",
  DISCOVER_PAGE_CARD_SUBSCRIBE = "discover_page_card_subscribe",
}

export enum PAGE_SECTIONS {
  COMEDIAN_PAGE_FEATURED = "comedian_page_featured",
  COMEDIAN_PAGE_TOUR = "comedian_page_tour",
  COMEDIAN_PAGE_VIDEOS = "comedian_page_videos",
  COMEDIAN_PAGE_ABOUT = "comedian_page_about",
  COMEDIAN_PAGE_PODCASTS = "comedian_page_podcasts",
  COMEDIAN_PAGE_PODCAST_DETAIL = "comedian_page_podcast_detail",
  COMEDIAN_PAGE_COLLECTIONS = "comedian_page_collections",
  COMEDIAN_PAGE_TICKETS = "comedian_page_tickets",
  EPISODE_CHECKOUT = "episode_checkout",
}

export enum CONTENT_TYPES {
  PODCAST_EPISODE = "podcast_episode",
  SPECIAL = "special",
  VIDEO = "video",
}

export enum NewsletterImportEvents {
  /** M21: the compose action bar's Import button clicked, opening the
   *  wizard. Properties: { comedianId }. */
  OPENED = "[Comedian Dashboard - Newsletter Import] Opened",
  /** M21: input submitted to the import pipeline. Properties:
   *  { comedianId, source: "docx-upload" | "google-docs", file_bytes? } —
   *  file_bytes applies to file sources only (a url submit has no size). */
  FILE_SUBMITTED = "[Comedian Dashboard - Newsletter Import] File Submitted",
  /** M21: the server pipeline returned a mapped doc. Properties:
   *  { comedianId, source, block_count, image_count, warning_count,
   *  duration_ms }. */
  SUCCEEDED = "[Comedian Dashboard - Newsletter Import] Succeeded",
  /** M21: the pipeline failed (parse/validation/network). Properties:
   *  { comedianId, source, duration_ms, reason }. */
  FAILED = "[Comedian Dashboard - Newsletter Import] Failed",
  /** M21: the previewed result applied into the compose canvas. Properties:
   *  { comedianId, source, mode: "replace" | "append", block_count }. */
  APPLIED = "[Comedian Dashboard - Newsletter Import] Applied to Canvas",
}

export enum ReleaseBoardEvents {
  /** The public /releases board rendered. Properties: { entry_count }. */
  VIEWED_BOARD = "Viewed Release Board",
  /** The audience filter changed. Properties: { audience: "all" | ReleaseAudience }. */
  FILTERED_BOARD = "Filtered Release Board",
  /** An entry's CTA link was clicked. Properties: { entry_id, entry_title, link_url }. */
  CLICKED_ENTRY_LINK = "Clicked Release Entry Link",
  /** "Show more" revealed more of the timeline. Properties: { scope: "months" | "rows", month? }. */
  EXPANDED_BOARD = "Expanded Release Board",
}

/**
 * The staff support assistant at /internal/support (docs/plans/support-assistant.md).
 * Properties never carry question, answer or case text — only ids, counts and
 * enums — because staff paste customer details into their questions.
 */
export enum SupportAssistantEvents {
  /** A question was sent. Properties: { conversationId?, isNewConversation }. */
  ASKED_QUESTION = "[Internal - Support Assistant] Asked Question",
  /** The answer finished streaming. Properties: { conversationId,
   *  citedCaseCount, searchCount, zeroResultSearches, citesUnverified,
   *  latencyMs }. */
  RECEIVED_ANSWER = "[Internal - Support Assistant] Received Answer",
  /** The turn failed. Properties: { conversationId?, code, retryable }. */
  ANSWER_ERROR = "[Internal - Support Assistant] Answer Error",
  /** A citation chip or source card was opened. Properties: { caseId,
   *  verification }. */
  CLICKED_CITATION = "[Internal - Support Assistant] Clicked Citation",
  /** A screenshot / recording / link was opened. Properties: { caseId,
   *  mediaKind }. */
  OPENED_MEDIA = "[Internal - Support Assistant] Opened Media",
  /** Thumbs up/down on an answer. Properties: { messageId, rating, reason? }. */
  RATED_ANSWER = "[Internal - Support Assistant] Rated Answer",
  /** Properties: { conversationId }. */
  RESOLVED_CONVERSATION = "[Internal - Support Assistant] Resolved Conversation",
  /** Properties: { conversationId }. */
  ESCALATED_CONVERSATION = "[Internal - Support Assistant] Escalated Conversation",
  /** The Slack-formatted escalation summary was copied. Properties:
   *  { conversationId }. */
  COPIED_ESCALATION_SUMMARY = "[Internal - Support Assistant] Copied Escalation Summary",
  /** "Turn into case" opened the editor with an AI draft. Properties:
   *  { conversationId }. */
  STARTED_CASE_FROM_CONVERSATION = "[Internal - Support Assistant] Started Case From Conversation",
  /** Properties: { caseId, source, status, mediaCount }. */
  CREATED_CASE = "[Internal - Support Assistant] Created Case",
  /** Properties: { caseId, mediaCount, contentChanged }. */
  UPDATED_CASE = "[Internal - Support Assistant] Updated Case",
  /** Properties: { caseId, action: "verify" | "unverify" }. */
  VERIFIED_CASE = "[Internal - Support Assistant] Verified Case",
  /** "Draft description" produced a media description. Properties:
   *  { accepted } — whether it was saved without being cleared. */
  USED_AI_DESCRIPTION = "[Internal - Support Assistant] Used AI Description",
  /** Properties: { sinceDays }. */
  VIEWED_GAPS = "[Internal - Support Assistant] Viewed Gaps",
}

/** Generic coaching-tour lifecycle, reported by `trackTourEvent` — { tour_id, tour_version, step_id, step_index, step_count }. */
export enum CoachingTourEvents {
  STEP_VIEWED = "[Coaching Tour] Step Viewed",
  CTA_CLICKED = "[Coaching Tour] CTA Clicked",
  DISMISSED = "[Coaching Tour] Dismissed",
  COMPLETED = "[Coaching Tour] Completed",
}

/** The automations checkout page — { artistId, tier, interval, surface } (surface: settings | automations_tab); Checkout Paid adds returnPath ("inline" | "redirect", the 3DS return). */
export enum AutomationsCheckoutEvents {
  CHECKOUT_STARTED = "[Comedian Dashboard - Automations Checkout] Checkout Started",
  CHECKOUT_PAID = "[Comedian Dashboard - Automations Checkout] Checkout Paid",
  CUSTOM_REQUEST_SENT = "[Comedian Dashboard - Automations Checkout] Custom Request Sent",
}

/** The card modal — { artistId, retried, surface } (surface: billing | automations_tab, the lapsed-plan Reactivate). */
export enum AutomationsBillingEvents {
  CARD_SAVED = "[Comedian Dashboard - Automations Billing] Card Saved",
}
